import React, { Component } from 'react';
import './index.scss';
import PurchaseFooter from '../Footer';
import FnbCategoriesHeader from './FnbCategoriesHeader';
import FnbItemCard from './FnbItemCard';
import AgeRestriction from './AgeRestriction';
import Modifiers from './Modifiers/index';
import queryString from 'query-string';
import Loader from '../../pages/loader';
import * as API from '../../configuration/apiconfig';
import Skeleton from 'react-loading-skeleton';
import { ReactComponent as IncrementIcon } from './Images/increment-icon.svg';
import { ReactComponent as DecrementIcon } from './Images/decrement-icon.svg';
import Swal from 'sweetalert2';
import { showAlert } from '../../components/showAlert';
import voucherErrorIcon from '../../assets/images/voucher-error-icon.svg';

import { orderExpiredRedirect } from '../../utils/AlertHandling';
import { craeteFnBPayloadForOrdersEndpoint } from '../../utils/PopulateFnbObject.js';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { BsCartCheckFill } from 'react-icons/bs';
import BookingSummary from '../BookingSummary/index.js';
class FNBComponent extends Component {
  constructor(props) {
    const parsedQueryString = queryString.parse(window.location.search);
    const params = new URLSearchParams(window.location.search);
    let cinemaId = params.get('cinemaid');
    super(props);
    this.state = {
      fnbData: [],
      ticketsDataForTicketSummary: [],
      fnbDataForTicketSummary: [],
      ticketsTaxValue: 0,
      fnbTaxValue: 0,
      activeCategoryIndex: 0,
      fnbActiveItemIndex: '-',
      showModifierModal: false,
      showAgeRestrictionModal: false,
      selectedItem: {},
      selectedItemId: '',
      cart: [],
      windowWidth: 0,
      ageVerified: false,
      sessionId: parsedQueryString.sessionid,
      cinemaId: parsedQueryString.cinemaid,
      orderId: parsedQueryString.orderid,
      bookingId: parsedQueryString.bookingid,
      orderType: localStorage.getItem('orderType'),
      orderData: [],
      dataLoading: true,
      alcoholItemsInCartCount: 0,
      alcoholItemsLimitPerOrder: window.constant.ALCOHOL_ITEMS_LIMIT_PER_ORDER ? window.constant.ALCOHOL_ITEMS_LIMIT_PER_ORDER : 5,
      isLoading: false,
      itemsAddedToCart: [],
      voucherFnbData: [],
      voucherFnbDataLoading: window.constant.ENABLE_VOUCHERS == 'true' ? true : false,
      showDeliveryTypeDrawer: false,
      deliveryTypeSelectionEnabled:
        window.constant.SHOW_DELIVERY_TYPE.ALL_LOCATIONS == true ? window.constant.SHOW_DELIVERY_TYPE.ALL_LOCATIONS : window.constant.SHOW_DELIVERY_TYPE.ACTIVE_LOCATIONS.includes(cinemaId),
      showBookingSelectionDrawer: false,
      bookedTicketDetails: {},
      pendingOrderObject: {},
      isPickupAvailable: [],
      deliveryTypeError: '',
      forcePickupSelection: false,

      freeRecognitionItemsData: [],
      setFreeFnbItemsData: [],
      freeFnbItemsDataLoading: true,
      openTicketSummary: false,
      backBtnClicked: false,
    };
  }

  componentDidMount() {
    console.log('FNBComponent > DidMound');
    let getCartData = JSON.parse(localStorage.getItem('cartData'));

    console.log(getCartData, 'getCartData');
    if (getCartData) {
      if (getCartData.expiry < Date.now()) {
        localStorage.removeItem('selectedSeats');
        localStorage.removeItem('cartData');
        localStorage.removeItem('orderId');
        getCartData = null;
      } else {
        this.setState(
          {
            cart: getCartData.cart,
          },
          () => {
            this.populateFnbDataForPurchaseFooter(false);
          }
        );
      }
    }

    if (this.state.orderType === 'ticketing') {
      this.getOrderData();
    }

    let width = window.innerWidth;
    this.setState({
      windowWidth: width,
    });

    let FnbHeader = document.getElementById('fnb-categories-header');
    let ItemsList = document.querySelector('.fnb-items-container');
    if (!FnbHeader || !ItemsList) return;
    let FnbHeaderTop = FnbHeader.offsetTop;
    window.addEventListener('scroll', () => {
      if (window.scrollY > FnbHeaderTop) {
        FnbHeader.classList.add('is-fixed');
        // // // // // ItemsList.style.paddingTop = `${FnbHeader.offsetHeight + 10}px`;
        ItemsList.classList.add('fnbCategoriesHeaderFixed');
      } else {
        FnbHeader.classList.remove('is-fixed');
        // // // // // ItemsList.style.paddingTop = 0;
        ItemsList.classList.remove('fnbCategoriesHeaderFixed');
      }
    });
    this.setState({
      fnbData: this.props.fnbData,
      dataLoading: false,
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.fnbData !== this.props.fnbData) {
      this.setState(
        {
          fnbData: this.props.fnbData,
          dataLoading: false,
        },
        () => {
          this.getFreeRecognitionFnbItem();
        }
      );
    }
    if (this.props.voucherFnbData.length != 0 && this.state.voucherFnbData.length == 0) {
      var voucherFnbData = this.props.voucherFnbData;
      voucherFnbData.map(category => {
        category.fnbtabs_items.map(item => {
          item.totalItemsAdded = 0;
          item.disableVoucherItem = false;
        });
      });
      this.setState(
        {
          voucherFnbData,
          voucherFnbDataLoading: false,
        },
        async () => {
          // Logic to enable/disable voucher fnbItem
          if (window.constant.ENABLE_VOUCHERS == 'true') {
            let getCartData = JSON.parse(localStorage.getItem('cartData'));
            if (getCartData) {
              await this.updateFNBCountInvoucherFnbData(this.state.cart, true);
              this.populateFnbDataForPurchaseFooter(false);
            }
          }
        }
      );
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', () => {});
    window.removeEventListener('scroll', () => {});
  }

  getOrderData = () => {
    const { orderId } = this.state;
    API.callEndpoint('GET', 'Bearer', `/order/v2/orders?id=${orderId}`)
      .then(res => {
        console.log(res, 'order data');
        let tempOrderData = [];
        var tempOrderResData = res.data;
        let ticketsTaxValue = 0;
        res.data[0].order_grouping.map(eachTicket => {
          if (eachTicket.type.toLowerCase() == 'ticket') {
            ticketsTaxValue += eachTicket.taxValue;
            let eachTaxValue = eachTicket.taxValue / eachTicket.quantity;
            let tempTicketObject = {
              description: eachTicket.description,
              unitprice: eachTicket.unitprice - eachTaxValue,
              qty: eachTicket.quantity,
            };
            if (window.constant.ENABLE_VOUCHERS === 'true') {
              console.log('REACT_APP_ENABLE_VOUCHERS');
              const currentItemCode = eachTicket.code;
              console.log('currentItemCode: ', currentItemCode);
              var orderinfoTickets = tempOrderResData[0].orderinfo;
              console.log('orderinfoTickets: ', orderinfoTickets);
              var filterTicketsBasedOnCode = orderinfoTickets.tickets.filter(x => x.code == currentItemCode);
              console.log('filterTicketsBasedOnCode: ', filterTicketsBasedOnCode);
              if (filterTicketsBasedOnCode.length > 0) {
                var voucherCodeArr = [];
                filterTicketsBasedOnCode.map(item => {
                  item?.voucherCode && voucherCodeArr.push(item.voucherCode);
                });
                console.log('voucherCodeArr: ', voucherCodeArr);
                // // // // // tempTicketObject.voucherCode = voucherCodeArr.length > 0 ? voucherCodeArr.toString() : "";
                tempTicketObject.voucherCode = voucherCodeArr.length > 0 ? voucherCodeArr.join(', ') : '';
              }
            }
            tempOrderData.push(tempTicketObject);
          }
        });
        console.log('tempOrderDatay: ', tempOrderData);
        this.setState(
          {
            ticketsDataForTicketSummary: tempOrderData,
            orderData: res.data,
            ticketsTaxValue,
          },
          () => {
            console.log('this.state.ticketsDataForTicketSummary: ', this.state.ticketsDataForTicketSummary);
          }
        );
      })
      .catch(err => {
        var errMsg = err.error.toLowerCase();
        showAlert({
          html: `<p>Sorry<span>${err.error}</span></p>`,
          iconHtml: `<img src="/assets/images/info-icon.svg" alt="info" />`,
          showCancelButton: false,
          cancelButtonText: 'CANCEL',
          showConfirmButton: true,
          confirmButtonText: errMsg.includes('expire') || errMsg.includes('no order found') ? 'OK' : 'Try again',
          allowOutsideClick: false,
          allowEscapeKey: false,
          iconClasses: 'borderless',
          popupClasses: 'common-error-alert',
          onConfirm: () => {
            var getMovieName = localStorage.getItem('selectedmoviename');
            var redirectURL = `/showtime?title=${getMovieName}`;
            orderExpiredRedirect(errMsg, redirectURL);
          },
          onCancel: () => {},
        });
      });
  };

  handleActiveCategory = index => {
    this.setState(
      {
        itemsAddedToCart: [],
      },
      () => {
        this.setState({
          activeCategoryIndex: index,
          fnbActiveItemIndex: '-',
        });
      }
    );
  };

  addToCartButtonClick = (index, tabId, fnbItem) => {
    var activeCategoryIndex = this.props.fnbData.findIndex(x => x.id === tabId);
    let fnbData = this.state.fnbData;
    let isFreeFNBItem = false;

    if (window.constant.FREE_RECOGNITION_ITEM && activeCategoryIndex < 0) {
      activeCategoryIndex = this.state.setFreeFnbItemsData.findIndex(x => x.id === tabId);
      fnbData = this.state.setFreeFnbItemsData;
      isFreeFNBItem = true;
    }

    if (this.checkFnbItemLimitAlert(fnbItem, isFreeFNBItem)) return;

    if (this.checkAlcoholItemsLimit(this.state.alcoholItemsInCartCount)) return;
    this.setState(
      {
        fnbActiveItemIndex: index,
        activeCategoryIndex,
      },
      () => {
        var { activeCategoryIndex, fnbActiveItemIndex, cart } = this.state;
        var ageRestrictionFlag = window.constant.AGE_RESTRICTION == 'true' && localStorage.getItem('ageRestrictionValidation') == null ? fnbData[activeCategoryIndex].ageRestriction : false;
        ageRestrictionFlag = this.state.ageVerified ? false : ageRestrictionFlag;
        // console.log('ageRestrictionFlag >>>>> ', ageRestrictionFlag);
        if (
          fnbData[activeCategoryIndex].fnbtabs_items[fnbActiveItemIndex].modifierGroups.length == 0 &&
          fnbData[activeCategoryIndex].fnbtabs_items[fnbActiveItemIndex].smartModifiers.length == 0 &&
          fnbData[activeCategoryIndex].fnbtabs_items[fnbActiveItemIndex].fnbs_alternateitems.length == 0 &&
          !ageRestrictionFlag
        ) {
          var itemUniqueIdentifier = fnbData[activeCategoryIndex].fnbtabs_items[fnbActiveItemIndex].id;
          var existingItemIndex = this.state.cart.findIndex(x => x.itemUniqueIdentifier == itemUniqueIdentifier);
          var existingCartData = JSON.parse(JSON.stringify(this.state.cart));
          var cart = [];
          if (existingItemIndex == -1) {
            cart = [
              ...existingCartData,
              {
                ...fnbData[activeCategoryIndex].fnbtabs_items[fnbActiveItemIndex],
                selectedQty: 1,
                itemUniqueIdentifier: itemUniqueIdentifier,
                ageRestrictionStatus: fnbData[activeCategoryIndex].ageRestriction,
                tabId: tabId,
                inSeatDelivery: fnbData[activeCategoryIndex].fnbtabs_items[fnbActiveItemIndex].inSeatDelivery,
                pickupAtCounter: fnbData[activeCategoryIndex].fnbtabs_items[fnbActiveItemIndex].pickupAtCounter,
              },
            ];
          } else {
            existingCartData[existingItemIndex].selectedQty = existingCartData[existingItemIndex].selectedQty + 1;
            cart = existingCartData;
          }
          this.setState(
            {
              cart: cart,
            },
            () => {
              this.showItemsAddedToCartMsg(itemUniqueIdentifier, fnbData[activeCategoryIndex].fnbtabs_items[fnbActiveItemIndex].itemName);
              this.handleFreeItemLimit(cart);
              this.showItemsAddedToCartMsg(itemUniqueIdentifier, fnbData[activeCategoryIndex].fnbtabs_items[fnbActiveItemIndex].itemName);
              this.populateFnbDataForPurchaseFooter(true);
            }
          );
        } else {
          this.setState(
            {
              showModifierModal: window.constant.AGE_RESTRICTION == 'true' ? (ageRestrictionFlag && localStorage.getItem('ageRestrictionValidation') == null ? false : true) : true,
              showAgeRestrictionModal: window.constant.AGE_RESTRICTION == 'true' ? (ageRestrictionFlag && localStorage.getItem('ageRestrictionValidation') == null ? true : false) : false,
              selectedItem: {
                ...fnbData[this.state.activeCategoryIndex].fnbtabs_items[index],
                selectedQty: 1,
                modifierGroups: fnbData[this.state.activeCategoryIndex].fnbtabs_items[index].modifierGroups.map(modGrp => {
                  return {
                    ...modGrp,
                    modifier_items: modGrp.modifier_items.map(modItem => {
                      if (modGrp.modifier_items.length == 1 && modGrp.minQty > 0 && modGrp.minQty == modGrp.maxQty) {
                        return { ...modItem, selectedQty: modGrp.minQty, addBtnDisabled: false };
                      } else {
                        return { ...modItem, selectedQty: 0, addBtnDisabled: false };
                      }
                    }),
                  };
                }),
                smartModifiers: fnbData[this.state.activeCategoryIndex].fnbtabs_items[index].smartModifiers.map(smartMod => {
                  return {
                    ...smartMod,
                    remove: false,
                    addAsSide: false,
                  };
                }),
                fnbs_alternateitems: fnbData[this.state.activeCategoryIndex].fnbtabs_items[index].fnbs_alternateitems.map(alternateItem => {
                  return {
                    ...alternateItem,
                    selectedQty: 0,
                  };
                }),
                ageRestrictionStatus: fnbData[this.state.activeCategoryIndex].ageRestriction,
                tabId: tabId,
                inSeatDelivery: fnbData[this.state.activeCategoryIndex].fnbtabs_items[index].inSeatDelivery,
                pickupAtCounter: fnbData[this.state.activeCategoryIndex].fnbtabs_items[index].pickupAtCounter,
                addBtnDisabled: false,
              },
              selectedItemId: fnbData[this.state.activeCategoryIndex].fnbtabs_items[index].id,
            },
            () => {
              const { selectedItem } = this.state;
              this.addBtnDisabled(selectedItem.maximumqty, selectedItem.selectedQty, 'fnbItemAddBtn');
              var getMonthElem = document.getElementById('month');
              if (getMonthElem) {
                getMonthElem.focus();
              }
            }
          );
        }
      }
    );
  };

  addToCartButtonClickVouchers = (index, tabId) => {
    var activeCategoryIndex = this.state.voucherFnbData.findIndex(x => x.id === tabId);
    if (this.checkAlcoholItemsLimit(this.state.alcoholItemsInCartCount)) return;
    this.setState(
      {
        fnbActiveItemIndex: index,
        activeCategoryIndex,
      },
      () => {
        var { activeCategoryIndex, fnbActiveItemIndex, cart } = this.state;
        var ageRestrictionFlag =
          window.constant.AGE_RESTRICTION == 'true' && localStorage.getItem('ageRestrictionValidation') == null ? this.state.voucherFnbData[activeCategoryIndex].ageRestriction : false;
        ageRestrictionFlag = this.state.ageVerified ? false : ageRestrictionFlag;
        console.log('ageRestrictionFlag >>>>> ', ageRestrictionFlag);
        if (
          this.state.voucherFnbData[activeCategoryIndex].fnbtabs_items[fnbActiveItemIndex].modifierGroups.length == 0 &&
          this.state.voucherFnbData[activeCategoryIndex].fnbtabs_items[fnbActiveItemIndex].smartModifiers.length == 0 &&
          this.state.voucherFnbData[activeCategoryIndex].fnbtabs_items[fnbActiveItemIndex].fnbs_alternateitems.length == 0 &&
          !ageRestrictionFlag
        ) {
          var itemUniqueIdentifier = this.state.voucherFnbData[activeCategoryIndex].fnbtabs_items[fnbActiveItemIndex].id;
          if (window.constant.ENABLE_VOUCHERS === 'true' && this.state.voucherFnbData[activeCategoryIndex].fnbtabs_items[fnbActiveItemIndex].hasOwnProperty('voucherCodes')) {
            itemUniqueIdentifier = 'voucherItem' + itemUniqueIdentifier;
          }
          var existingItemIndex = this.state.cart.findIndex(x => x.itemUniqueIdentifier == itemUniqueIdentifier);
          var existingCartData = JSON.parse(JSON.stringify(this.state.cart));
          var cart = [];
          if (existingItemIndex == -1) {
            // Adding / Updating voucher code(s) based on Qty.
            if (window.constant.ENABLE_VOUCHERS == 'true') {
              var vouchersCodes = this.state.voucherFnbData[activeCategoryIndex].fnbtabs_items[fnbActiveItemIndex].voucherCodes;
              if (vouchersCodes && vouchersCodes.length > 0) {
                this.state.voucherFnbData[activeCategoryIndex].fnbtabs_items[fnbActiveItemIndex].vouchersCodesApplied = [];
                var vouchersCodesAppliedArr = [];
                var cartData = JSON.parse(JSON.stringify(this.state.cart));
                cartData.map(cartItem => {
                  var cartItemWithSameDealId = this.state.cart.filter(x => x.voucherDealId && cartItem.voucherDealId && x.voucherDealId === cartItem.voucherDealId);
                  if (cartItemWithSameDealId.length > 0) {
                    // Items with same DealID.
                    cartItemWithSameDealId.map(sameDealIdItem => {
                      var cartItemVouchersCodesApplied = sameDealIdItem.vouchersCodesApplied;
                      if (cartItemVouchersCodesApplied.length > 1) {
                        cartItemVouchersCodesApplied.map(x => {
                          vouchersCodesAppliedArr.push(x);
                        });
                      } else {
                        vouchersCodesAppliedArr.push(cartItemVouchersCodesApplied[0]);
                      }
                    });
                  } else {
                    // Items with different DealID.
                    if (cartItem.id == this.state.voucherFnbData[activeCategoryIndex].fnbtabs_items[fnbActiveItemIndex].id && cartItem.hasOwnProperty('vouchersCodesApplied')) {
                      if (cartItem.vouchersCodesApplied.length > 1) {
                        cartItem.vouchersCodesApplied.map(x => {
                          vouchersCodesAppliedArr.push(x);
                        });
                      } else {
                        vouchersCodesAppliedArr.push(cartItem.vouchersCodesApplied[0]);
                      }
                    }
                  }
                  // // // // // if (cartItem.id == this.state.voucherFnbData[activeCategoryIndex].fnbtabs_items[fnbActiveItemIndex].id) {
                  // // // // //   if (cartItem.vouchersCodesApplied.length > 1) {
                  // // // // //     cartItem.vouchersCodesApplied.map((x) => {
                  // // // // //       vouchersCodesAppliedArr.push(x);
                  // // // // //     });
                  // // // // //   } else {
                  // // // // //     vouchersCodesAppliedArr.push(cartItem.vouchersCodesApplied[0]);
                  // // // // //   }
                  // // // // // }
                });
                console.log('existingItemIndex == -1 > vouchersCodesAppliedArr.length: ', vouchersCodesAppliedArr);
                if (vouchersCodesAppliedArr.length > 0) {
                  console.log('existingItemIndex == -1 > vouchersCodesAppliedArr.length>0: ');
                  let remainingVoucherCodes = vouchersCodes.filter(e => !vouchersCodesAppliedArr.includes(e));
                  this.state.voucherFnbData[activeCategoryIndex].fnbtabs_items[fnbActiveItemIndex].vouchersCodesApplied.push(remainingVoucherCodes[0]);
                } else {
                  console.log('existingItemIndex == -1 > vouchersCodesAppliedArr<=0');
                  this.state.voucherFnbData[activeCategoryIndex].fnbtabs_items[fnbActiveItemIndex].vouchersCodesApplied.push(
                    this.state.voucherFnbData[activeCategoryIndex].fnbtabs_items[fnbActiveItemIndex].voucherCodes[0]
                  );
                }
              }
            }

            cart = [
              ...existingCartData,
              {
                ...this.state.voucherFnbData[activeCategoryIndex].fnbtabs_items[fnbActiveItemIndex],
                selectedQty: 1,
                itemUniqueIdentifier: itemUniqueIdentifier,
                ageRestrictionStatus: this.state.voucherFnbData[activeCategoryIndex].ageRestriction,
                tabId: tabId,
              },
            ];
          } else {
            existingCartData[existingItemIndex].selectedQty = existingCartData[existingItemIndex].selectedQty + 1;

            // Adding / Updating voucher code(s) based on Qty.
            if (window.constant.ENABLE_VOUCHERS == 'true') {
              var vouchersCodes = existingCartData[existingItemIndex].voucherCodes;
              if (vouchersCodes && vouchersCodes.length > 0) {
                var vouchersCodesAppliedArr = [];
                existingCartData.map(cartItem => {
                  var cartItemWithSameDealId = this.state.cart.filter(x => x.voucherDealId && cartItem.voucherDealId && x.voucherDealId === cartItem.voucherDealId);
                  if (cartItemWithSameDealId.length > 0) {
                    // Items with same DealID.
                    cartItemWithSameDealId.map(sameDealIdItem => {
                      var cartItemVouchersCodesApplied = sameDealIdItem.vouchersCodesApplied;
                      if (cartItemVouchersCodesApplied.length > 1) {
                        cartItemVouchersCodesApplied.map(x => {
                          vouchersCodesAppliedArr.push(x);
                        });
                      } else {
                        vouchersCodesAppliedArr.push(cartItemVouchersCodesApplied[0]);
                      }
                    });
                  } else {
                    // Items with different DealID.
                    if (cartItem.id == existingCartData[existingItemIndex].id && cartItem.hasOwnProperty('vouchersCodesApplied')) {
                      var cartItemVouchersCodesApplied = cartItem.vouchersCodesApplied;
                      if (cartItemVouchersCodesApplied.length > 1) {
                        cartItemVouchersCodesApplied.map(x => {
                          vouchersCodesAppliedArr.push(x);
                        });
                      } else {
                        vouchersCodesAppliedArr.push(cartItemVouchersCodesApplied[0]);
                      }
                    }
                  }
                  // // // // // if (cartItem.id == existingCartData[existingItemIndex].id) {
                  // // // // //   if (cartItem.vouchersCodesApplied.length > 1) {
                  // // // // //     cartItem.vouchersCodesApplied.map((x) => {
                  // // // // //       vouchersCodesAppliedArr.push(x);
                  // // // // //     });
                  // // // // //   } else {
                  // // // // //     vouchersCodesAppliedArr.push(cartItem.vouchersCodesApplied[0]);
                  // // // // //   }
                  // // // // // }
                });
                console.log('existingItemIndex != -1 > vouchersCodesAppliedArr: ', vouchersCodesAppliedArr);
                let remainingVoucherCodes = vouchersCodes.filter(e => !vouchersCodesAppliedArr.includes(e));
                existingCartData[existingItemIndex].vouchersCodesApplied.push(remainingVoucherCodes[0]);
              }
            }

            cart = existingCartData;
          }
          this.setState(
            {
              cart: cart,
            },
            async () => {
              // Logic to enable/disable voucher fnbItem
              if (window.constant.ENABLE_VOUCHERS == 'true') {
                await this.updateFNBCountInvoucherFnbData(this.state.cart, false);
              }
              this.showItemsAddedToCartMsg(itemUniqueIdentifier, this.state.voucherFnbData[activeCategoryIndex].fnbtabs_items[fnbActiveItemIndex].itemName);
              this.populateFnbDataForPurchaseFooter(true);
            }
          );
        } else {
          this.setState(
            {
              showModifierModal: window.constant.AGE_RESTRICTION == 'true' ? (ageRestrictionFlag && localStorage.getItem('ageRestrictionValidation') == null ? false : true) : true,
              showAgeRestrictionModal: window.constant.AGE_RESTRICTION == 'true' ? (ageRestrictionFlag && localStorage.getItem('ageRestrictionValidation') == null ? true : false) : false,
              selectedItem: {
                ...this.state.voucherFnbData[this.state.activeCategoryIndex].fnbtabs_items[index],
                selectedQty: 1,
                modifierGroups: this.state.voucherFnbData[this.state.activeCategoryIndex].fnbtabs_items[index].modifierGroups.map(modGrp => {
                  return {
                    ...modGrp,
                    modifier_items: modGrp.modifier_items.map(modItem => {
                      if (modGrp.modifier_items.length == 1 && modGrp.minQty > 0 && modGrp.minQty == modGrp.maxQty) {
                        return { ...modItem, selectedQty: modGrp.minQty, addBtnDisabled: false };
                      } else {
                        return { ...modItem, selectedQty: 0, addBtnDisabled: false };
                      }
                    }),
                  };
                }),
                smartModifiers: this.state.voucherFnbData[this.state.activeCategoryIndex].fnbtabs_items[index].smartModifiers.map(smartMod => {
                  return {
                    ...smartMod,
                    remove: false,
                    addAsSide: false,
                  };
                }),
                fnbs_alternateitems: this.state.voucherFnbData[this.state.activeCategoryIndex].fnbtabs_items[index].fnbs_alternateitems.map(alternateItem => {
                  return {
                    ...alternateItem,
                    selectedQty: 0,
                  };
                }),
                ageRestrictionStatus: this.state.voucherFnbData[this.state.activeCategoryIndex].ageRestriction,
                tabId: tabId,
                addBtnDisabled: false,
              },
              selectedItemId: this.state.voucherFnbData[this.state.activeCategoryIndex].fnbtabs_items[index].id,
            },
            () => {
              var getMonthElem = document.getElementById('month');
              if (getMonthElem) {
                getMonthElem.focus();
              }
            }
          );
        }
      }
    );
  };

  showItemsAddedToCartMsg = (itemUniqueIdentifier, itemName) => {
    var addIndex = this.state.itemsAddedToCart.findIndex(x => x.id === itemUniqueIdentifier);
    var addedObject,
      tempDirectItemsAddedToCart = [];

    if (addIndex == -1) {
      addedObject = { id: itemUniqueIdentifier, name: itemName, qty: 1 };
      tempDirectItemsAddedToCart = [...this.state.itemsAddedToCart, { ...addedObject }];
    } else {
      tempDirectItemsAddedToCart = JSON.parse(JSON.stringify(this.state.itemsAddedToCart));
      tempDirectItemsAddedToCart[addIndex].qty += 1;
      tempDirectItemsAddedToCart[addIndex].id = tempDirectItemsAddedToCart[addIndex].id + '-' + tempDirectItemsAddedToCart[addIndex].qty;
    }

    this.setState(
      {
        itemsAddedToCart: tempDirectItemsAddedToCart,
      },
      () => {
        var self = this;
        setTimeout(() => {
          var removeIndex = this.state.itemsAddedToCart.findIndex(x => x.id === itemUniqueIdentifier);
          var replaceDirectItemsAddedToCart = JSON.parse(JSON.stringify(this.state.itemsAddedToCart));
          replaceDirectItemsAddedToCart.splice(removeIndex, 1);
          self.setState({
            itemsAddedToCart: replaceDirectItemsAddedToCart,
          });
        }, 2500);
      }
    );
  };

  closeModifierPopup = () => {
    this.setState({
      showModifierModal: false,
    });
  };

  closeBtnAgeRestrictionPopup = () => {
    this.setState({
      showAgeRestrictionModal: false,
    });
  };

  closeAgeRestrictionPopup = (clearSelectedItem, ageVerified) => {
    this.setState(
      {
        showAgeRestrictionModal: false,
        selectedItem: clearSelectedItem == true ? {} : { ...this.state.selectedItem },
        selectedItemId: '',
        ageVerified: !ageVerified,
      },
      () => {
        localStorage.setItem('ageRestrictionValidation', 'true');
        var { activeCategoryIndex, fnbActiveItemIndex, cart } = this.state;
        if (
          this.props.fnbData[activeCategoryIndex].fnbtabs_items[fnbActiveItemIndex].modifierGroups.length == 0 &&
          this.props.fnbData[activeCategoryIndex].fnbtabs_items[fnbActiveItemIndex].smartModifiers.length == 0 &&
          this.props.fnbData[activeCategoryIndex].fnbtabs_items[fnbActiveItemIndex].fnbs_alternateitems.length == 0 &&
          !clearSelectedItem
        ) {
          var itemUniqueIdentifier = this.props.fnbData[activeCategoryIndex].fnbtabs_items[fnbActiveItemIndex].id;
          if (window.constant.ENABLE_VOUCHERS === 'true' && this.props.fnbData[activeCategoryIndex].fnbtabs_items[fnbActiveItemIndex].hasOwnProperty('voucherCodes')) {
            itemUniqueIdentifier = 'voucherItem' + itemUniqueIdentifier;
          }
          this.setState(
            {
              cart: [
                ...cart,
                {
                  ...this.props.fnbData[activeCategoryIndex].fnbtabs_items[fnbActiveItemIndex],
                  selectedQty: 1,
                  ageRestrictionStatus: this.props.fnbData[activeCategoryIndex].ageRestriction,
                  itemUniqueIdentifier,
                },
              ],
            },
            () => {
              this.populateFnbDataForPurchaseFooter(true);
            }
          );
        } else {
          this.setState({
            showModifierModal: clearSelectedItem ? false : true,
          });
        }
      }
    );
  };

  populateItemImage = () => {
    if (this.state.showModifierModal && this.state.fnbActiveItemIndex != null) {
      return <img src={this.state.selectedItem.fnbs_images[0]?.imageurl} className="modifierPopupItemImage" />;
    }
  };

  populateModifierPrice = modifierItem => {
    if (modifierItem.valuebeforetax != 0) {
      if (modifierItem.strikeValueBeforeTax == null) {
        return <span className="modifierItemPrice">${modifierItem.valuebeforetax.toFixed(2)}</span>;
      } else {
        return (
          <div>
            <span className="modifierItemPrice">${modifierItem.strikeValueBeforeTax.toFixed(2)}</span>
            <span className="modifierItemPrice strikePrice">${modifierItem.valuebeforetax.toFixed(2)}</span>
          </div>
        );
      }
    }
  };

  populateModifierItem = (modifierGroup, modifierGroupIndex, modifierItem, modifierItemIndex) => {
    var type = '',
      value;
    if (modifierGroup.maxQty > 1 && modifierGroup.minQty >= 0 && !(modifierGroup.maxQty == 1 && modifierGroup.minQty == 1)) {
      type = 'incDec';
    } else if (modifierGroup.maxQty <= 1 && modifierGroup.minQty == 0) {
      type = 'checkbox';
    } else if (modifierGroup.maxQty == 1 && modifierGroup.minQty == 1) {
      type = 'radio';
    } else if (modifierGroup == '' && modifierGroupIndex == '') {
      type = 'smartMod';
    } else if (modifierGroup == 'alternateItem') {
      type = 'alternateItem';
    }

    switch (type) {
      case 'checkbox':
        value = (
          <div
            className={`modifierItem ${modifierItem.active == false ? 'disabled' : ''} ${modifierItem.selectedQty == 0 ? '' : 'selected'}`}
            onClick={() => this.incDecModItem(modifierGroupIndex, modifierItemIndex, '', 'checkbox')}
          >
            <img
              src={modifierItem.modifiers_images.length > 0 ? modifierItem.modifiers_images[0].imageurl : '#'}
              width={window.constant.MODIFIER_ITEM_IMAGE_WIDTH}
              height={window.constant.MODIFIER_ITEM_IMAGE_HEIGHT}
            />
            <div className="modifierItemContent">
              <p className="name">{modifierItem.itemName}</p>
              <p className="description">{modifierItem.itemDetails}</p>
              <div className="priceAndCart">
                <p className="price">{this.populateModifierPrice(modifierItem)}</p>
              </div>
            </div>
            <input
              className="form-check-input modiferItemName"
              type="checkbox"
              name={modifierGroup.tabid}
              id={modifierGroup.tabid + modifierItemIndex}
              checked={modifierItem.selectedQty > 0 ? true : false}
              onClick={() => this.incDecModItem(modifierGroupIndex, modifierItemIndex, '', 'checkbox')}
            />
          </div>
        );
        break;
      case 'radio':
        value = (
          <div
            className={`modifierItem ${modifierItem.active == false ? 'disabled' : ''} ${modifierItem.selectedQty == 0 ? '' : 'selected'}`}
            onClick={() => this.incDecModItem(modifierGroupIndex, modifierItemIndex, '', 'radio')}
          >
            <img
              src={modifierItem.modifiers_images.length > 0 ? modifierItem.modifiers_images[0].imageurl : '#'}
              width={window.constant.MODIFIER_ITEM_IMAGE_WIDTH}
              height={window.constant.MODIFIER_ITEM_IMAGE_HEIGHT}
            />
            <div className="modifierItemContent">
              <p className="name">{modifierItem.itemName}</p>
              <p className="description">{modifierItem.itemDetails}</p>
              <div className="priceAndCart">
                <p className="price">{this.populateModifierPrice(modifierItem)}</p>
              </div>
            </div>
            <input
              className="form-check-input modiferItemName"
              type="radio"
              name={modifierGroup.tabid}
              id={modifierGroup.tabid + modifierItemIndex}
              checked={modifierItem.selectedQty > 0 ? true : false}
              onClick={() => this.incDecModItem(modifierGroupIndex, modifierItemIndex, '', 'radio')}
            />
          </div>
        );
        break;
      case 'incDec':
        value = (
          <div className={`modifierItem ${modifierItem.active == false ? 'disabled' : ''} ${modifierItem.selectedQty == 0 ? '' : 'selected'}`}>
            <img
              src={modifierItem.modifiers_images.length > 0 ? modifierItem.modifiers_images[0].imageurl : '#'}
              width={window.constant.MODIFIER_ITEM_IMAGE_WIDTH}
              height={window.constant.MODIFIER_ITEM_IMAGE_HEIGHT}
            />
            <div className="modifierItemContent">
              <p className="name">{modifierItem.itemName}</p>
              <p className="description">{modifierItem.itemDetails}</p>
              <div className="priceAndCart">
                <p className="price">{this.populateModifierPrice(modifierItem)}</p>
                <div className="incDec">
                  <div className="incDecButtonDiv">
                    <button
                      type="button"
                      className={`btn btn-outline-secondary decButton ${modifierItem.selectedQty == 0 ? 'd-none' : 'borderTopRadiusZero'}`}
                      onClick={() => this.incDecModItem(modifierGroupIndex, modifierItemIndex, 'subtract', 'incDec')}
                    >
                      <DecrementIcon className="dec-img" />
                    </button>
                    <span className="selectedQty">{modifierItem.selectedQty == 0 ? '' : `${modifierItem.selectedQty}`}</span>
                    <button
                      type="button"
                      className={`btn btn-outline-secondary incButton ${this.checkIfModItemReachedMaxQty(modifierGroup) && modifierGroup.maxQty != 0 ? 'disabled' : ''} ${
                        modifierItem.selectedQty == 0 ? '' : 'borderBottomRadiusZero'
                      }`}
                      onClick={() => this.incDecModItem(modifierGroupIndex, modifierItemIndex, 'add', 'incDec')}
                    >
                      <IncrementIcon className="inc-img" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
        break;
      case 'smartMod':
        value = (
          <div className={`form-check incDec smartMod ${modifierItem.active == false ? 'disabled' : ''}`}>
            <div className="incDecButtonDiv smartMod">
              <label className="form-check-label" for={modifierItem.id}>
                <span className="modifierItemName smartMod">
                  <span className="hypen">-</span>
                  {modifierItem.itemName}
                </span>
              </label>
              <div className="remove-btn">
                <button
                  type="button"
                  className={`btn btn-outline-secondary incButton smartModBtn ${modifierItem.addAsSide ? 'active' : ''}`}
                  onClick={() => this.smartModClick(modifierItemIndex, 'addAsSide')}
                >
                  &nbsp;
                </button>
              </div>
              <div className="add-btn">
                <button
                  type="button"
                  className={`btn btn-outline-secondary decButton smartModBtn ${modifierItem.remove ? 'active' : ''}`}
                  onClick={() => this.smartModClick(modifierItemIndex, 'remove')}
                >
                  &nbsp;
                </button>
              </div>
            </div>
          </div>
        );
        break;
      case 'alternateItem':
        value = (
          <div className={`modifierItem ${modifierItem.active == false ? 'disabled' : ''} ${modifierItem.selectedQty == 0 ? '' : 'selected'}`}>
            <img
              src={modifierItem.fnbs_images.length > 0 ? modifierItem.fnbs_images[0].imageurl : '#'}
              width={window.constant.MODIFIER_ITEM_IMAGE_WIDTH}
              height={window.constant.MODIFIER_ITEM_IMAGE_HEIGHT}
            />
            <div className="modifierItemContent">
              <p className="name">{modifierItem.itemName}</p>
              <p className="description">{modifierItem.itemDetails}</p>
              <div className="priceAndCart">
                <p className="price">{this.populateModifierPrice(modifierItem)}</p>
                <div className="incDec">
                  <div className="incDecButtonDiv">
                    <button
                      type="button"
                      className={`btn btn-outline-secondary decButton ${modifierItem.selectedQty == 0 ? 'd-none' : 'borderTopRadiusZero'}`}
                      onClick={() => this.incDecAlternateItem('subtract', modifierItemIndex)}
                    >
                      <DecrementIcon className="dec-img" />
                    </button>
                    <span className="selectedQty">{modifierItem.selectedQty == 0 ? '' : `${modifierItem.selectedQty}`}</span>
                    <button
                      type="button"
                      className={`btn btn-outline-secondary incButton ${modifierItem.maximumqty > 0 && modifierItem.selectedQty >= modifierItem.maximumqty ? 'disabled' : ''} ${modifierItem.selectedQty == 0 ? '' : 'borderBottomRadiusZero'}`}
                      onClick={() => this.incDecAlternateItem('add', modifierItemIndex)}
                    >
                      <IncrementIcon className="inc-img" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
        break;
      default:
        value = <></>;
        break;
    }
    return value;
  };

  checkIfModItemReachedMaxQty = modifierGroup => {
    var maxQty = modifierGroup.maxQty,
      totalSelectQty = 0,
      returnBoolean = false;
    modifierGroup.modifier_items.map(eachModifierItem => {
      totalSelectQty += eachModifierItem.selectedQty;
    });
    if (maxQty == totalSelectQty || totalSelectQty >> maxQty) {
      returnBoolean = true;
    }
    return returnBoolean;
  };

  incDecModItem = (modifierGroupIndex, modifierItemIndex, operator, type) => {
    var getSelectedItemsData = JSON.parse(JSON.stringify(this.state.selectedItem));
    if (type == 'radio') {
      getSelectedItemsData = {
        ...getSelectedItemsData,
        modifierGroups: getSelectedItemsData.modifierGroups.map((modGroup, modGroupIndex) => {
          if (modGroupIndex == modifierGroupIndex) {
            return {
              ...modGroup,
              modifier_items: modGroup.modifier_items.map(modItem => {
                return { ...modItem, selectedQty: 0 };
              }),
            };
          } else {
            return { ...modGroup };
          }
        }),
      };

      let findSelectedId = getSelectedItemsData.modifierGroups[modifierGroupIndex].tabid + modifierItemIndex;
      let selectedCheckbox = document.getElementById(findSelectedId);
      if (selectedCheckbox) {
        selectedCheckbox.checked = true;
      }
    }

    if (type == 'radio' || type == 'checkbox') {
      if (getSelectedItemsData.modifierGroups[modifierGroupIndex].modifier_items[modifierItemIndex].selectedQty == 0) {
        operator = 'add';
        if (type == 'checkbox') {
          let findSelectedId = getSelectedItemsData.modifierGroups[modifierGroupIndex].tabid + modifierItemIndex;
          let selectedCheckbox = document.getElementById(findSelectedId);
          if (selectedCheckbox) {
            selectedCheckbox.checked = true;
          }
        }
      } else {
        operator = 'subtract';
        if (type == 'checkbox') {
          let findSelectedId = getSelectedItemsData.modifierGroups[modifierGroupIndex].tabid + modifierItemIndex;
          let selectedCheckbox = document.getElementById(findSelectedId);
          if (selectedCheckbox) {
            selectedCheckbox.checked = false;
          }
        }
      }
    }

    if (type == 'checkbox' && getSelectedItemsData.modifierGroups[modifierGroupIndex].maxQty == 1) {
      getSelectedItemsData = {
        ...getSelectedItemsData,
        modifierGroups: getSelectedItemsData.modifierGroups.map((modGroup, modGroupIndex) => {
          if (modGroupIndex == modifierGroupIndex) {
            return {
              ...modGroup,
              modifier_items: modGroup.modifier_items.map(modItem => {
                return { ...modItem, selectedQty: 0 };
              }),
            };
          } else {
            return { ...modGroup };
          }
        }),
      };
    }

    if (operator == 'add') {
      getSelectedItemsData.modifierGroups[modifierGroupIndex].modifier_items[modifierItemIndex].selectedQty += 1;
    } else if (operator == 'subtract' && getSelectedItemsData.modifierGroups[modifierGroupIndex].modifier_items[modifierItemIndex].selectedQty != 0) {
      getSelectedItemsData.modifierGroups[modifierGroupIndex].modifier_items[modifierItemIndex].selectedQty -= 1;
    }

    if (type == 'alternateItem') {
      getSelectedItemsData.fnbs_alternateitems = getSelectedItemsData.fnbs_alternateitems.map((alternateitem, alternateItemIndex) => {
        return { ...alternateitem, selectedQty: modifierItemIndex == alternateItemIndex ? 1 : 0 };
      });
    }
    this.setState({
      selectedItem: getSelectedItemsData,
      selectedItemId: getSelectedItemsData.id,
    });
  };

  smartModClick = (modifierItemIndex, type) => {
    var getSelectedItemsData = JSON.parse(JSON.stringify(this.state.selectedItem));
    if (type == 'addAsSide') {
      getSelectedItemsData.smartModifiers[modifierItemIndex]['remove'] = false;
    }
    if (type == 'remove') {
      getSelectedItemsData.smartModifiers[modifierItemIndex]['addAsSide'] = false;
    }
    getSelectedItemsData.smartModifiers[modifierItemIndex][type] = !getSelectedItemsData.smartModifiers[modifierItemIndex][type];

    this.setState({
      selectedItem: getSelectedItemsData,
      selectedItemId: getSelectedItemsData.id,
    });
  };

  incDecAlternateItem = (operator, item) => {
    var itemData = JSON.parse(JSON.stringify(this.state.selectedItem));
    if (!itemData.fnbs_alternateitems || itemData.fnbs_alternateitems.length == 0 || item == null || item == undefined) {
      return;
    }

    const alternateItem = itemData.fnbs_alternateitems[item];
    if (!alternateItem) {
      return;
    }

    if (operator == 'add') {
      if (this.checkAlcoholItemsLimit(this.state.alcoholItemsInCartCount)) return;
      if (alternateItem.maximumqty > 0 && alternateItem.selectedQty >= alternateItem.maximumqty) {
        this.showFnbItemLimitAlert(alternateItem);
        return;
      }
      alternateItem.selectedQty += 1;
    } else if (operator == 'subtract' && alternateItem.selectedQty > 0) {
      alternateItem.selectedQty -= 1;
    }

    this.setState(
      {
        selectedItem: itemData,
        selectedItemId: itemData.id,
      },
      () => {
        this.populateFnbDataForPurchaseFooter(true);
      }
    );
  };

  incDecItem = (operator, itemIndex) => {
    console.log('itemIndex: ', itemIndex);
    if (operator == 'add') {
      if (this.checkAlcoholItemsLimit(this.state.alcoholItemsInCartCount)) return;
    }

    var itemData = [];
    if (itemIndex.length == 0) {
      console.log('itemIndex.length == 0');
      itemData = JSON.parse(JSON.stringify(this.state.selectedItem));
      if (operator == 'add') {
        console.log('itemIndex.length == 0 > add');
        itemData.selectedQty += 1;
        itemData.addBtnDisabled = this.addBtnDisabled(itemData.maximumqty, itemData.selectedQty, 'modifierItemAddBtn');
      } else if (operator == 'subtract' && itemData.selectedQty != 1) {
        console.log('itemIndex.length == 0 > subtract');
        itemData.selectedQty -= 1;
        itemData.addBtnDisabled = this.addBtnDisabled(itemData.maximumqty, itemData.selectedQty, 'modifierItemAddBtn');
      }
      this.setState(
        {
          selectedItem: itemData,
          selectedItemId: itemData.id,
        },
        () => {
          this.populateFnbDataForPurchaseFooter(true);
        }
      );
    } else {
      console.log('itemIndex.length > 0');
      itemData = JSON.parse(JSON.stringify(this.state.cart));
      if (operator == 'add') {
        console.log('itemIndex.length > 0 > add');
        itemData[itemIndex].selectedQty += 1;

        // Adding / Updating voucher code(s) based on Qty.
        if (window.constant.ENABLE_VOUCHERS == 'true') {
          var vouchersCodes = itemData[itemIndex].voucherCodes;
          if (vouchersCodes && vouchersCodes.length > 0) {
            var cartItemWithSameDealId = this.state.cart.filter(x => x.voucherDealId && itemData[itemIndex].voucherDealId && x.voucherDealId === itemData[itemIndex].voucherDealId);
            if (cartItemWithSameDealId.length > 0) {
              // Items with same DealID.
              var vouchersCodesAppliedArr = [];
              cartItemWithSameDealId.map(sameDealIdItem => {
                var cartItemVouchersCodesApplied = sameDealIdItem.vouchersCodesApplied;
                if (cartItemVouchersCodesApplied.length > 1) {
                  cartItemVouchersCodesApplied.map(x => {
                    vouchersCodesAppliedArr.push(x);
                  });
                } else {
                  vouchersCodesAppliedArr.push(cartItemVouchersCodesApplied[0]);
                }
              });
              let remainingVoucherCodes = vouchersCodes.filter(e => !vouchersCodesAppliedArr.includes(e));
              itemData[itemIndex].vouchersCodesApplied.push(remainingVoucherCodes[0]);
            } else {
              // Items with different DealID.
              if (itemData[itemIndex].vouchersCodesApplied) {
                var vouchersCodesApplied = itemData[itemIndex].vouchersCodesApplied;
                let remainingVoucherCodes = vouchersCodes.filter(e => !vouchersCodesApplied.includes(e));
                itemData[itemIndex].vouchersCodesApplied.push(remainingVoucherCodes[0]);
              }
            }
            // // // // // var vouchersCodesApplied = itemData[itemIndex].vouchersCodesApplied;
            // // // // // let remainingVoucherCodes = vouchersCodes.filter((e) => !vouchersCodesApplied.includes(e));
            // // // // // itemData[itemIndex].vouchersCodesApplied.push(remainingVoucherCodes[0]);
          }
        }
      } else if (operator == 'subtract' && itemData.selectedQty != 1) {
        console.log('itemIndex.length > 0 > subtract');
        itemData[itemIndex].selectedQty -= 1;

        // Removing vouchercode(s) based on Qty.
        if (window.constant.ENABLE_VOUCHERS == 'true') {
          var vouchersCodes = itemData[itemIndex].voucherCodes;
          if (vouchersCodes && vouchersCodes.length > 0) {
            var vouchersCodesApplied = itemData[itemIndex].vouchersCodesApplied;
            vouchersCodesApplied.shift();
            itemData[itemIndex].vouchersCodesApplied = vouchersCodesApplied;
          }
        }
      }
      console.log('itemIndex.length > 0 > itemData[itemIndex].selectedQty: ', itemData[itemIndex].selectedQty);
      if (itemData[itemIndex].selectedQty == 0) {
        // // // // // this.removeItemFromCart(itemIndex);
        this.setState(
          {
            selectedItemId: itemData[itemIndex].id,
          },
          () => {
            this.removeItemFromCart(itemIndex);
          }
        );
      } else {
        this.setState(
          {
            cart: itemData,
            selectedItemId: itemData[itemIndex].id,
          },
          async () => {
            this.handleFreeItemLimit(itemData);
            // Logic to enable/disable voucher fnbItem
            if (window.constant.ENABLE_VOUCHERS == 'true') {
              await this.updateFNBCountInvoucherFnbData(this.state.cart, false);
            }
            this.populateFnbDataForPurchaseFooter(true);
          }
        );
      }
    }
  };

  addBtnDisabled = (maximumqty, selectedQty, clickEvent) => {
    console.log(maximumqty, 'maximumqty');
    console.log(selectedQty, 'selectedQty');
    const { fnbDataForTicketSummary, selectedItem } = this.state;
    var disabled = false;
    if (maximumqty <= selectedQty) {
      // console.log('Modifier add >> without booking summary');
      disabled = true;
    } else {
      if (fnbDataForTicketSummary.length > 0 && Object.keys(selectedItem).length > 0) {
        var getSelectedItemCount = fnbDataForTicketSummary.filter(x => x.description.toLowerCase() == selectedItem.itemName.toLowerCase());
        var totalItemCount = 0;
        if (getSelectedItemCount.length > 0) {
          getSelectedItemCount.forEach(item => {
            totalItemCount += item.qty;
          });
          var addedTotalQuantity = totalItemCount + selectedQty;
          if (clickEvent == 'modifierItemAddBtn') {
            // console.log('Modifier add >> with booking summary--Plus btn click');
            disabled = maximumqty <= addedTotalQuantity ? true : false;
          } else if (clickEvent == 'fnbItemAddBtn') {
            // console.log('Modifier add >> with booking summary--fnb item add btn click');
            selectedItem.addBtnDisabled = maximumqty <= addedTotalQuantity ? true : false;
            this.setState({ selectedItem });
          }
        }
      } else {
        disabled = false;
      }
    }
    return disabled;
  };

  calculateItemTotal = () => {
    const { selectedItem } = this.state;
    let itemPricePerUnit = 0,
      modifiersPrice = 0,
      selectedQuantity = 0;
    const itemQty = selectedItem.selectedQty;

    if (selectedItem.fnbs_alternateitems.length == 0) {
      selectedQuantity = selectedItem.selectedQty;
      itemPricePerUnit = selectedItem.strikeValueBeforeTax == null ? selectedItem.valuebeforetax : selectedItem.strikeValueBeforeTax;
      selectedItem.modifierGroups.forEach(modGroup => {
        // Collect all selected modifier items and their prices
        let selectedModifiers = [];
        modGroup.modifier_items.forEach(modItem => {
          if (modItem.selectedQty > 0) {
            let price = modItem.strikeValueBeforeTax == null ? modItem.valuebeforetax : modItem.strikeValueBeforeTax;
            for (let i = 0; i < modItem.selectedQty; i++) {
              selectedModifiers.push(price);
            }
          }
        });
        // Sort prices ascending (cheapest first)
        selectedModifiers.sort((a, b) => a - b);
        // Only positive-priced modifiers can consume freeQty.
        let freeQty = modGroup.freeQty || 0;
        let remainingFreeQty = freeQty;
        let paidModifiers = [];
        selectedModifiers.forEach(price => {
          if (price > 0 && remainingFreeQty > 0) {
            remainingFreeQty -= 1;
          } else {
            paidModifiers.push(price);
          }
        });
        modifiersPrice += paidModifiers.reduce((sum, price) => sum + price, 0);
      });
    } else {
      selectedItem.fnbs_alternateitems.forEach(alternateItem => {
        if (alternateItem.selectedQty > 0) {
          const alternateItemPrice = alternateItem.strikeValueBeforeTax == null ? alternateItem.valuebeforetax : alternateItem.strikeValueBeforeTax;
          const effectiveQty = alternateItem.selectedQty * selectedItem.selectedQty;
          selectedQuantity += effectiveQty;
          modifiersPrice += alternateItemPrice * effectiveQty;
        }
      });
    }
    return {
      price: (selectedItem.fnbs_alternateitems.length == 0 ? itemQty * (itemPricePerUnit + modifiersPrice) : modifiersPrice).toFixed(2),
      itemQty: selectedItem.fnbs_alternateitems.length == 0 ? selectedQuantity : selectedQuantity,
    };
  };

  checkIfBtnIsDisabled = () => {
    var selectedItem = this.state.selectedItem,
      modGrpQtyArray = [],
      disabledFlag = false,
      countRequired = 0;

    selectedItem.modifierGroups.map(modGroup => {
      var totalModItemSelectedQty = 0;
      modGroup.modifier_items.map(modItem => {
        totalModItemSelectedQty += modItem.selectedQty;
      });
      modGrpQtyArray.push({ minQty: modGroup.minQty, totalModItemSelectedQty, maxQty: modGroup.maxQty });
    });

    modGrpQtyArray.map(eachModGroupQty => {
      if (eachModGroupQty.minQty != 0 && eachModGroupQty.totalModItemSelectedQty < eachModGroupQty.minQty) {
        if (eachModGroupQty.minQty > eachModGroupQty.maxQty) {
          return null;
        }
        // console.log('inside if');
        countRequired += 1;
        disabledFlag = true;
      }
    });

    return countRequired;
  };

  proceedBtnClick = () => {
    var selectedItem = JSON.parse(JSON.stringify(this.state.selectedItem));
    const selectedAlternateItems = (selectedItem.fnbs_alternateitems || []).filter(alternateItem => alternateItem.selectedQty != 0);

    if (selectedAlternateItems.length > 0) {
      let cart = JSON.parse(JSON.stringify(this.state.cart));
      let totalItemsToAdd = 0;
      const addedItemNames = [];

      selectedAlternateItems.forEach(alternateItem => {
        const quantityToAdd = alternateItem.selectedQty * selectedItem.selectedQty;
        if (quantityToAdd <= 0) {
          return;
        }

        totalItemsToAdd += quantityToAdd;
        addedItemNames.push(`${alternateItem.itemName}${quantityToAdd > 1 ? ` x${quantityToAdd}` : ''}`);

        const directAlternateItem = {
          ...alternateItem,
          selectedQty: quantityToAdd,
          itemUniqueIdentifier: alternateItem.id,
          ageRestrictionStatus: selectedItem.ageRestrictionStatus,
          tabId: selectedItem.tabId,
          inSeatDelivery: alternateItem?.inSeatDelivery != null ? alternateItem.inSeatDelivery : selectedItem.inSeatDelivery,
          pickupAtCounter: alternateItem?.pickupAtCounter != null ? alternateItem.pickupAtCounter : selectedItem.pickupAtCounter,
          fnbs_alternateitems: [],
        };

        const existingItemIndex = cart.findIndex(x => x.itemUniqueIdentifier == directAlternateItem.itemUniqueIdentifier);
        if (existingItemIndex == -1) {
          cart = [...cart, directAlternateItem];
        } else {
          cart[existingItemIndex].selectedQty = cart[existingItemIndex].selectedQty + quantityToAdd;
        }
      });

      if (selectedItem.ageRestrictionStatus == 1 && this.state.alcoholItemsInCartCount + totalItemsToAdd > this.state.alcoholItemsLimitPerOrder) {
        this.showOrderLimitAlert();
        return;
      }

      this.setState(
        {
          cart,
          selectedItem: {},
          showModifierModal: false,
        },
        async () => {
          if (window.constant.ENABLE_VOUCHERS == 'true') {
            await this.updateFNBCountInvoucherFnbData(this.state.cart, false);
          }
          this.showItemsAddedToCartMsg(selectedItem.id, addedItemNames.join(', '));
          this.populateFnbDataForPurchaseFooter(true);
        }
      );
      return;
    }

    if (this.checkAlcoholItemsLimit(this.state.alcoholItemsInCartCount)) return;
    var itemUniqueIdentifier = selectedItem.id;
    if (window.constant.ENABLE_VOUCHERS === 'true' && selectedItem.hasOwnProperty('voucherCodes')) {
      itemUniqueIdentifier = 'voucherItem' + itemUniqueIdentifier;
    }
    var itemName = selectedItem.itemName;
    if (selectedItem.modifierGroups.length != 0) {
      selectedItem.modifierGroups.map(modGroup => {
        var modifiersArray = [];
        modGroup.modifier_items.map(modItem => {
          modifiersArray.push(modItem.modifierid + modItem.selectedQty);
        });
        itemUniqueIdentifier = itemUniqueIdentifier + modifiersArray.sort().join('');
      });
    }

    if (selectedItem.smartModifiers.length != 0) {
      var smartModifiersArray = [];
      selectedItem.smartModifiers.map(smartModifier => {
        console.log(smartModifier.id);
        var smartModifierType = '';
        if (smartModifier.addAsSide) {
          smartModifierType += 'addAsSide';
        }
        if (smartModifier.remove) {
          smartModifierType += 'remove';
        }
        smartModifiersArray.push(smartModifier.id + smartModifierType);
      });
      itemUniqueIdentifier = itemUniqueIdentifier + smartModifiersArray.sort().join('');
    }

    var existingItemIndex = this.state.cart.findIndex(x => x.itemUniqueIdentifier == itemUniqueIdentifier);
    var cart = [];

    if (existingItemIndex == -1) {
      console.log('existingItemIndex == -1');
      // Adding / Updating voucher code(s) based on Qty.
      if (window.constant.ENABLE_VOUCHERS == 'true') {
        var vouchersCodes = selectedItem.voucherCodes;
        if (vouchersCodes && vouchersCodes.length > 0) {
          selectedItem.vouchersCodesApplied = [];
          var vouchersCodesAppliedArr = [];
          var cartData = JSON.parse(JSON.stringify(this.state.cart));
          cartData.map(cartItem => {
            var cartItemWithSameDealId = this.state.cart.filter(x => x.voucherDealId && cartItem.voucherDealId && x.voucherDealId === cartItem.voucherDealId);
            console.log('cartItemWithSameDealId: ', cartItemWithSameDealId);
            if (cartItemWithSameDealId.length > 0) {
              // Items with same DealID.
              cartItemWithSameDealId.map(sameDealIdItem => {
                var cartItemVouchersCodesApplied = sameDealIdItem.vouchersCodesApplied;
                if (cartItemVouchersCodesApplied && cartItemVouchersCodesApplied.length > 1) {
                  cartItemVouchersCodesApplied.map(x => {
                    vouchersCodesAppliedArr.push(x);
                  });
                } else {
                  vouchersCodesAppliedArr.push(cartItemVouchersCodesApplied[0]);
                }
              });
            } else {
              // Items with different DealID.
              if (cartItem.id == selectedItem.id && cartItem.hasOwnProperty('vouchersCodesApplied')) {
                if (cartItem.vouchersCodesApplied.length > 1) {
                  cartItem.vouchersCodesApplied.map(x => {
                    vouchersCodesAppliedArr.push(x);
                  });
                } else {
                  vouchersCodesAppliedArr.push(cartItem.vouchersCodesApplied[0]);
                }
              }
            }

            // // // // // if (cartItem.id == selectedItem.id && cartItem.hasOwnProperty("vouchersCodesApplied")) {
            // // // // //   if (cartItem.vouchersCodesApplied.length > 1) {
            // // // // //     cartItem.vouchersCodesApplied.map((x) => {
            // // // // //       vouchersCodesAppliedArr.push(x);
            // // // // //     });
            // // // // //   } else {
            // // // // //     vouchersCodesAppliedArr.push(cartItem.vouchersCodesApplied[0]);
            // // // // //   }
            // // // // // }
          });
          console.log('existingItemIndex == -1 > vouchersCodesAppliedArr.length: ', vouchersCodesAppliedArr);
          if (vouchersCodesAppliedArr.length > 0) {
            console.log('existingItemIndex == -1 > vouchersCodesAppliedArr.length>0: ');
            let remainingVoucherCodes = vouchersCodes.filter(e => !vouchersCodesAppliedArr.includes(e));
            selectedItem.vouchersCodesApplied.push(remainingVoucherCodes[0]);
          } else {
            console.log('existingItemIndex == -1 > vouchersCodesAppliedArr<=0');
            selectedItem.vouchersCodesApplied.push(selectedItem.voucherCodes[0]);
          }
        }
      }

      cart = [...this.state.cart, { ...selectedItem, itemUniqueIdentifier: itemUniqueIdentifier }];
    } else {
      console.log('existingItemIndex != -1');
      var existingCartData = JSON.parse(JSON.stringify(this.state.cart));
      existingCartData[existingItemIndex].selectedQty = existingCartData[existingItemIndex].selectedQty + selectedItem.selectedQty;

      // Adding / Updating voucher code(s) based on Qty.
      if (window.constant.ENABLE_VOUCHERS == 'true') {
        var vouchersCodes = existingCartData[existingItemIndex].voucherCodes;
        if (vouchersCodes && vouchersCodes.length > 0) {
          var vouchersCodesAppliedArr = [];
          existingCartData.map(cartItem => {
            var cartItemWithSameDealId = this.state.cart.filter(x => x.voucherDealId && cartItem.voucherDealId && x.voucherDealId === cartItem.voucherDealId);
            if (cartItemWithSameDealId.length > 0) {
              // Items with same DealID.
              cartItemWithSameDealId.map(sameDealIdItem => {
                var cartItemVouchersCodesApplied = sameDealIdItem.vouchersCodesApplied;
                if (cartItemVouchersCodesApplied.length > 1) {
                  cartItemVouchersCodesApplied.map(x => {
                    vouchersCodesAppliedArr.push(x);
                  });
                } else {
                  vouchersCodesAppliedArr.push(cartItemVouchersCodesApplied[0]);
                }
              });
            } else {
              // Items with different DealID.
              if (cartItem.id == existingCartData[existingItemIndex].id && cartItem.hasOwnProperty('vouchersCodesApplied')) {
                var cartItemVouchersCodesApplied = cartItem.vouchersCodesApplied;
                if (cartItemVouchersCodesApplied.length > 1) {
                  cartItemVouchersCodesApplied.map(x => {
                    vouchersCodesAppliedArr.push(x);
                  });
                } else {
                  vouchersCodesAppliedArr.push(cartItemVouchersCodesApplied[0]);
                }
              }
            }

            // // // // // if (cartItem.id == existingCartData[existingItemIndex].id) {
            // // // // //   var cartItemVouchersCodesApplied = cartItem.vouchersCodesApplied;
            // // // // //   if (cartItemVouchersCodesApplied.length > 1) {
            // // // // //     cartItemVouchersCodesApplied.map((x) => {
            // // // // //       vouchersCodesAppliedArr.push(x);
            // // // // //     });
            // // // // //   } else {
            // // // // //     vouchersCodesAppliedArr.push(cartItemVouchersCodesApplied[0]);
            // // // // //   }
            // // // // // }
          });
          console.log('existingItemIndex != -1 > vouchersCodesAppliedArr: ', vouchersCodesAppliedArr);
          let remainingVoucherCodes = vouchersCodes.filter(e => !vouchersCodesAppliedArr.includes(e));
          existingCartData[existingItemIndex].vouchersCodesApplied.push(remainingVoucherCodes[0]);
        }
      }

      cart = existingCartData;
    }

    if (selectedItem.ageRestrictionStatus == 1 && this.state.alcoholItemsInCartCount + selectedItem.selectedQty > this.state.alcoholItemsLimitPerOrder) {
      this.showOrderLimitAlert();
      return;
    } else {
      this.setState(
        {
          cart: cart,
          selectedItem: {},
          // // // // // selectedItemId: "",
          showModifierModal: false,
        },
        async () => {
          // Logic to enable/disable voucher fnbItem
          if (window.constant.ENABLE_VOUCHERS == 'true') {
            await this.updateFNBCountInvoucherFnbData(this.state.cart, false);
          }
          this.showItemsAddedToCartMsg(itemUniqueIdentifier, itemName);
          this.populateFnbDataForPurchaseFooter(true);
        }
      );
    }
  };

  populateFnbDataForPurchaseFooter = updateOrderFunctionisAvailable => {
    this.updateAlcoholItemsInCartCount(this.state.cart);
    var fnbDataForTicketSummary = [];
    let fnbTaxValue = 0;
    this.state.cart.map(fnbItem => {
      fnbTaxValue += fnbItem.taxValue;
      var disableIncOption = false;
      if (window.constant.ENABLE_VOUCHERS === 'true') {
        if (this.state.voucherFnbData.length > 0) {
          console.log('populateFnbDataForPurchaseFooter()');
          var itemIndex = this.state.voucherFnbData[0].fnbtabs_items.findIndex(x => x.hasOwnProperty('voucherCodes') && fnbItem.hasOwnProperty('voucherCodes') && x.id === fnbItem.id);
          if (itemIndex != -1) {
            disableIncOption = this.state.voucherFnbData[0].fnbtabs_items[itemIndex].disableVoucherItem;
          }
        }
      }

      if (fnbItem.fnbs_alternateitems.length == 0) {
        var modifierGroups = fnbItem.modifierGroups.map(modGroup => {
          return {
            id: modGroup.id || modGroup.groupid || modGroup.modifierGroupId,
            freeQty: modGroup.freeQty || 0,
            modifier_items: modGroup.modifier_items.map(modItem => {
              return {
                ...modItem,
                modifierid: modItem.modifierid || '',
                isSoldOut: modItem?.isSoldOut,
              };
            }),
          };
        });
        var modifiers = [];
        fnbItem.modifierGroups.map(modGroup => {
          modGroup.modifier_items.map(modItem => {
            if (modItem.selectedQty >= 1) {
              fnbTaxValue += modItem.taxValue;
              modifiers.push({
                description: modItem.itemName,
                unitprice: modItem.strikeValueBeforeTax == null ? modItem.valuebeforetax : modItem.strikeValueBeforeTax,
                qty: modItem.selectedQty,
                modifierGroupId: modGroup.id || modGroup.groupid || modGroup.modifierGroupId,
                modifierid: modItem.modifierid || '',
                isSoldOut: modItem?.isSoldOut,
              });
            }
          });
        });
        var smartModifiers = fnbItem.smartModifiers
          .filter(smartModifier => {
            return smartModifier.addAsSide == true || smartModifier.remove == true;
          })
          .map(smartModifier => {
            if (smartModifier.addAsSide) {
              return {
                description: smartModifier.itemName + ' (Add as side)',
                unitprice: smartModifier.strikeValueBeforeTax == null ? smartModifier.valuebeforetax : smartModifier.strikeValueBeforeTax,
                qty: 1,
              };
            }
            if (smartModifier.remove) {
              return {
                description: smartModifier.itemName + ' (Remove)',
                unitprice: smartModifier.strikeValueBeforeTax == null ? smartModifier.valuebeforetax : smartModifier.strikeValueBeforeTax,
                qty: 1,
              };
            }
          });
        var fnbObject = {
          description: fnbItem.itemName,
          unitprice: fnbItem.strikeValueBeforeTax == null ? fnbItem.valuebeforetax : fnbItem.strikeValueBeforeTax,
          qty: fnbItem.selectedQty,
          fnbid: fnbItem.fnbid || '',
          modifierGroups: modifierGroups,
          modifiers: modifiers,
          smartModifiers: smartModifiers,
          originalPrice: fnbItem.strikeValueBeforeTax == null ? null : fnbItem.valuebeforetax,
          disableIncOption: disableIncOption,
          inSeatDelivery: fnbItem?.inSeatDelivery,
          pickupAtCounter: fnbItem?.pickupAtCounter,
          maximumqty: fnbItem.maximumqty,
          isSoldOut: fnbItem?.isSoldOut,
        };
        if (window.constant.ENABLE_VOUCHERS === 'true') {
          if (fnbItem.vouchersCodesApplied && fnbItem.vouchersCodesApplied.length > 0) {
            var vouchersCodesAppliedArr = fnbItem.vouchersCodesApplied;
            // // // // // fnbObject.voucherCode = vouchersCodesAppliedArr.toString();
            fnbObject.voucherCode = vouchersCodesAppliedArr.join(', ');
          } else {
            fnbObject.voucherCode = '';
          }
          fnbObject.voucherDealId = fnbItem.voucherDealId ? fnbItem.voucherDealId : '';
          fnbObject.voucherType = fnbItem.voucherType ? fnbItem.voucherType : '';
        }
        fnbDataForTicketSummary.push(fnbObject);
      } else {
        var selectedItem = fnbItem;
        selectedItem.fnbs_alternateitems.forEach(alternateItem => {
          if (alternateItem.selectedQty > 0) {
            var fnbObject = {
              description: alternateItem.itemName,
              unitprice: alternateItem.strikeValueBeforeTax == null ? alternateItem.valuebeforetax : alternateItem.strikeValueBeforeTax,
              qty: alternateItem.selectedQty,
              fnbid: alternateItem.fnbid || '',
              modifierGroups: [],
              modifiers: [],
              smartModifiers: [],
              originalPrice: alternateItem.strikeValueBeforeTax == null ? null : alternateItem.valuebeforetax,
              disableIncOption: disableIncOption,
              inSeatDelivery: fnbItem?.inSeatDelivery,
              pickupAtCounter: fnbItem?.pickupAtCounter,
              maximumqty: alternateItem.maximumqty,
              isSoldOut: alternateItem?.isSoldOut,
            };
            if (window.constant.ENABLE_VOUCHERS === 'true') {
              fnbObject.voucherCodes = fnbItem.voucherCodes ? fnbItem.voucherCodes : '';
              fnbObject.voucherDealId = fnbItem.voucherDealId ? fnbItem.voucherDealId : '';
              fnbObject.voucherType = fnbItem.voucherType ? fnbItem.voucherType : '';
            }
            fnbDataForTicketSummary.push(fnbObject);
          }
        });
      }
    });
    // console.log(fnbDataForTicketSummary, "fnbDataForTicketSummary from populatefnbdataforpurchasefooter");
    this.setState(
      {
        fnbDataForTicketSummary,
        fnbTaxValue,
      },
      () => {
        if (updateOrderFunctionisAvailable) {
          this.checkIfUpdateOrderFunctionisAvailable();
        }
        // Add to cart > button click
        this.bookingSummaryPlusBtnDisabled();
      }
    );
  };

  bookingSummaryPlusBtnDisabled = () => {
    const { fnbDataForTicketSummary } = this.state;

    // Step 1: calculate total qty per description
    const qtyMap = {};

    fnbDataForTicketSummary.forEach(item => {
      if (!qtyMap[item.description]) {
        qtyMap[item.description] = 0;
      }
      qtyMap[item.description] += item.qty;
    });

    // Step 2: update addBtnDisabled
    const updatedData = fnbDataForTicketSummary.map(item => {
      const totalQty = qtyMap[item.description];

      return {
        ...item,
        addBtnDisabled: totalQty >= item.maximumqty,
      };
    });

    // Step 3: update state
    this.setState(
      {
        fnbDataForTicketSummary: updatedData,
      },
      () => {
        console.log(this.state.fnbDataForTicketSummary, 'fnbDataForTicketSummary--booking summary');
      }
    );
  };

  removeItemFromCart = fnbIndex => {
    var cart = JSON.parse(JSON.stringify(this.state.cart));
    cart.splice(fnbIndex, 1);
    this.setState(
      {
        cart,
      },
      async () => {
        this.handleFreeItemLimit(cart);
        // Logic to enable/disable voucher fnbItem
        if (window.constant.ENABLE_VOUCHERS == 'true') {
          await this.updateFNBCountInvoucherFnbData(this.state.cart, false);
        }
        this.populateFnbDataForPurchaseFooter();
      }
    );
  };

  updateOrderWithFnbData = async (redirectPath, fromNextBtn) => {
    // console.log(this.state.cart, "cart data");
    const orderDetails = JSON.parse(localStorage.getItem('orderId'));
    let orderId = orderDetails?.id;
    const expiry = orderId ? orderDetails?.expiry : new Date().getTime() + 720 * 1000;

    let firstName = API.getValueFromCookie('firstname');
    let lastName = API.getValueFromCookie('lastname');
    let fullName = (firstName ? firstName : '') + ' ' + (lastName ? lastName : '');
    let isFnbOrder = this.state.orderType === 'fnb';

    let fnbOrderData = craeteFnBPayloadForOrdersEndpoint(this.state.cart);
    // console.log(fnbOrderData, "fnbOrderData");
    let orderData = this.state.orderData;
    let orderObject = new Object();
    orderObject.sessionid = isFnbOrder ? (this.state.sessionId ? this.state.sessionId : this.state.bookedTicketDetails?.sessionId) : orderData[0].session.id;
    orderObject.fullname = fullName ? fullName : '';
    orderObject.firstname = firstName ? firstName : '';
    orderObject.lastname = lastName ? lastName : '';
    orderObject.email = '';
    orderObject.phonenumber = '';
    orderObject.tickettypes = isFnbOrder ? [] : orderData[0].orderinfo.tickets;
    orderObject.seats = isFnbOrder ? [] : orderData[0].orderinfo.seats;
    orderObject.fnb = fnbOrderData?.length > 0 ? fnbOrderData : [];
    orderObject.id = isFnbOrder ? (orderId ? orderId : '') : orderData[0].id;
    orderObject.cinemaid = this.state.cinemaId;
    if (isFnbOrder) {
      orderObject.deliveryseat = this.state.bookedTicketDetails?.deliveryseat ? this.state.bookedTicketDetails?.deliveryseat : '';
      orderObject.additionalInfo = {
        disableOfferItems: true,
      };
    }
    const inSeatItemsAvailable = orderObject.fnb.find(item => item.inSeatDelivery);
    console.log(orderObject, 'payload');



    if (window.constant.SHOW_DELIVERY_TYPE_DRAWER_BEFORE_BOOKING_SELECTION_DRAWER) {
      if (fromNextBtn === 'nextBtn' && this.state.deliveryTypeSelectionEnabled) {
        this.setState(
          {
            pendingOrderObject: orderObject,
            isPickupAvailable: [],
            deliveryTypeError: '',
            forcePickupSelection: false,
            showDeliveryTypeDrawer: true,
          }
        );
        return;
      }

      await this.handleUpdateOrderWithFnbData(orderObject, redirectPath);
    } else {
      //OLD FLOW: Shows booking details selection drawer first
      //TODO: Before Updating the order with fnb data call the pickup endpoint to check if pickup is available. If not available continue else show the Delivery type Drawer and based on User's selected Option Update the fnb items delivery type.
      // console.log(fromNextBtn, "fromNextBtn recieved to updateOrderWithFnbData");
      if (fromNextBtn === 'nextBtn' && this.state.deliveryTypeSelectionEnabled) {
        // console.log("continue btn clicked");

        if (this.state.orderType === 'fnb' && inSeatItemsAvailable) {
          this.setState({ pendingOrderObject: orderObject }, () => this.handleBookingSelectionDrawer());
        }

        if (!inSeatItemsAvailable) {
          const getOrderData = this.handleUpdateOrderWithFnbData(orderObject, redirectPath);
          return;
        }
        if (this.state.orderType != 'fnb' && inSeatItemsAvailable) {
          const isPickupAvailable = await this.checkPickupAvailability(orderObject);
          this.setState({ isLoading: false, pendingOrderObject: orderObject });
          const getOrderData = this.handleUpdateOrderWithFnbData(orderObject, redirectPath);
          return;
        }
      } else {
        console.log('skipped delivery type selection');
        const getOrderData = this.handleUpdateOrderWithFnbData(orderObject, redirectPath);
        // console.log(getOrderData, "getOrderData");
      }
    }
  };

  handleUpdateOrderWithFnbData = async (orderObject, redirectPath, deliveryType) => {
    // Check for printer status before order creation.
    const printerStatusResponse = await window?.callbackObj?.callCheckPrinterStatus?.();

    if (printerStatusResponse) {
      console.log(printerStatusResponse, 'printerStatus fnb', JSON.parse(printerStatusResponse).code);
      const response = JSON.parse(printerStatusResponse);

      if (response?.code !== '200') {
        showAlert({
          html: `<p class="fnb-disabled-text">Printer Error<span>${response.message}</p>`,
          iconHtml: `<img src="/assets/images/info-icon.svg" alt="info" />`,
          showConfirmButton: true,
          allowOutsideClick: false,
          allowEscapeKey: false,
          iconClasses: 'borderless',
          confirmButtonText: 'Go to Home',
          onConfirm: () => {
            window.location.href = `/?cinemaid=${localStorage.getItem('cinemaid')}`;
          },
        });

        return null;
      }
    }

    const orderDetails = JSON.parse(localStorage.getItem('orderId'));
    let orderId = orderDetails?.id;
    const expiry = orderId ? orderDetails?.expiry : new Date().getTime() + 720 * 1000;
    let isFnbOrder = this.state.orderType === 'fnb';
    let method;
    let orderUrl;
    if (isFnbOrder) {
      method = orderId ? 'PUT' : 'POST';
      orderUrl = this.state.bookedTicketDetails?.sessionId ? '/order/v2/orders' : '/order/v2/orders/concession';
    } else {
      method = 'PUT';
      orderUrl = '/order/v2/orders';
    }
    this.setState({ isLoading: true });
    return await API.callEndpoint(method, 'Bearer', orderUrl, orderObject)
      .then(response => {
        console.log(response.data, 'response data order update');
        const cartData = {
          cart: this.state.cart,
          expiry: expiry,
        };
        localStorage.setItem('cartData', JSON.stringify(cartData));
        let orderIdObject = new Object();
        orderIdObject.id = response.data[0].id;
        orderIdObject.expiry = expiry;
        localStorage.setItem('orderId', JSON.stringify(orderIdObject));
        // if (this.state.orderType === 'fnb') {
        //   this.handleShowDeliveryTypeDrawer();
        // }
        if (redirectPath) {
          window.location.href = redirectPath;
        } else {
          window.location.href = `/order-review?orderid=${response.data[0].id}`;
        }
        return response.data;
      })
      .catch(err => {
        // console.log(err, 'test err');

        // handle soldout items while creating order
        if (err?.code == 422) {
          this.handleSoldOutItems(err?.error);
          return;
        }

        var self = this;
        var errMsg = err.error.toLowerCase();
        console.log('errMsg lowerCase >>>>>', errMsg);
        showAlert({
          html: `<p>${err.error}</p>`,
          iconHtml: `<img src="/assets/images/info-icon.svg" alt="info" />`,
          showCancelButton: false,
          cancelButtonText: 'CANCEL',
          showConfirmButton: true,
          confirmButtonText: errMsg.includes('expire') || errMsg.includes('no order found') ? 'OK' : 'Try again',
          allowOutsideClick: false,
          allowEscapeKey: false,
          iconClasses: 'borderless',
          popupClasses: 'common-error-alert',
          onConfirm: () => {
            console.log(err, 'error');
            var getMovieName = localStorage.getItem('selectedmoviename');
            var redirectURL = `/showtime?title=${getMovieName}`;
            if (this.state.orderType === 'ticketing') {
              orderExpiredRedirect(errMsg, redirectURL);
            }
          },
          onCancel: () => {},
        });
        self.setState({
          isLoading: false,
        });
      })
      .finally(() => {
        this.setState({ isLoading: false });
      });
  };

  handleSoldOutItems = async soldOutItems => {
    let soldOutFnbItems = soldOutItems?.failedconcessions || [];
    let soldOutReqModifiers = soldOutItems?.failedconcessionModifiers || [];
    let soldOutModifiers = soldOutItems?.failedconcessionModifiersoptional || [];
    let fnbDataForTicketSummaryTemp = structuredClone(this.state.fnbDataForTicketSummary);
    let fnbDataTemp = structuredClone(this.props.fnbData);
    let cartData = structuredClone(this.state.cart);

    fnbDataForTicketSummaryTemp = fnbDataForTicketSummaryTemp.map(item => {
      //check for fnb items
      if (soldOutFnbItems.includes(String(item.fnbid))) {
        console.log('item in soldout items', item.fnbid);
        item.isSoldOut = true;
      }

      //check for modItems
      item.modifiers = item.modifiers.map(modItem => {
        console.log(modItem, 'testing each modItems');
        if (soldOutReqModifiers.includes(String(modItem.modifierid))) {
          modItem.isSoldOut = true;
          item.isSoldOut = true;
        }
        if (soldOutModifiers.includes(String(modItem.modifierid))) {
          modItem.isSoldOut = true;
        }
        return modItem;
      });

      return item;
    });

    fnbDataTemp = fnbDataTemp.map(category => {
      category.fnbtabs_items.map(item => {
        if (soldOutFnbItems.includes(String(item.fnbid))) {
          item.active = false;
        }

        item.modifierGroups.map(modGroup => {
          modGroup.modifier_items.map(modItem => {
            if (modItem.modifierid == 11844) {
              console.log(modItem, 'modITem found', soldOutReqModifiers.includes(modItem.modifierid), soldOutReqModifiers.includes(String(modItem.modifierid)));
            }
            if (soldOutReqModifiers.includes(String(modItem.modifierid))) {
              modItem.active = false;
            } else if (soldOutModifiers.includes(String(modItem.modifierid))) {
              modItem.active = false;
            }
            return modItem;
          });

          return modGroup;
        });

        return item;
      });
      return category;
    });

    cartData = cartData.map(cartItem => {
      if (soldOutFnbItems.includes(String(cartItem.fnbid))) {
        cartItem.isSoldOut = true;
      }

      //check for modItems
      cartItem.modifierGroups.map(modGroup => {
        modGroup.modifier_items.map(modItem => {
          if (soldOutReqModifiers.includes(String(modItem.modifierid))) {
            modItem.isSoldOut = true;
            cartItem.isSoldOut = true;
          } else if (soldOutModifiers.includes(String(modItem.modifierid))) {
            modItem.isSoldOut = true;
          }
          return modItem;
        });

        return modGroup;
      });

      return cartItem;
    });

    this.props.updateFnbDataState(fnbDataTemp);

    this.setState(
      {
        fnbDataForTicketSummary: fnbDataForTicketSummaryTemp,
        openTicketSummary: true,
        soldOutItems: soldOutItems,
        cart: cartData,
      },
      () => {
        // console.log('fnbData updated', this.props.fnbData);
      }
    );
  };

  handleContinueWithoutSoldOutItems = async () => {
    const { cart, soldOutItems } = this.state;

    const soldOutFnbIds = new Set((soldOutItems?.failedconcessions || []).map(String));
    const soldOutRequiredModifierIds = new Set((soldOutItems?.failedconcessionModifiers || []).map(String));
    const soldOutOptionalModifierIds = new Set((soldOutItems?.failedconcessionModifiersoptional || []).map(String));

    const nextCart = [];

    cart.forEach(item => {
      const itemId = String(item.fnbid);

      if (soldOutFnbIds.has(itemId)) {
        return;
      }

      const nextItem = structuredClone(item);

      const hasRequiredSoldOutModifier = nextItem.modifierGroups.some(modGroup =>
        modGroup.modifier_items.some(modItem => {
          const modifierId = String(modItem.modifierid);
          return soldOutRequiredModifierIds.has(modifierId);
        })
      );

      if (hasRequiredSoldOutModifier) {
        return;
      }

      nextItem.modifierGroups = (nextItem.modifierGroups || []).map(modGroup => ({
        ...modGroup,
        modifier_items: (modGroup.modifier_items || []).filter(modItem => {
          const modifierId = String(modItem.modifierid || '');
          return !soldOutRequiredModifierIds.has(modifierId) && !soldOutOptionalModifierIds.has(modifierId);
        }),
      }));

      nextItem.smartModifiers = (nextItem.smartModifiers || []).filter(smartModifier => {
        const modifierId = String(smartModifier.id || '');
        return !soldOutRequiredModifierIds.has(modifierId) && !soldOutOptionalModifierIds.has(modifierId);
      });

      nextCart.push(nextItem);
    });

    this.setState(
      {
        cart: nextCart,
        openTicketSummary: false,
      },
      async () => {
        let redirectPath = this.state.backBtnClicked && this.state.orderType === 'ticketing' ? `/seatlayout?sessionid=${localStorage.getItem('sesstionid')}` : false;
        // console.log(redirectPath, "testing redirect path handleContinueWithoutSoldOutItems");
        await this.populateFnbDataForPurchaseFooter(false);
        if (nextCart.length > 0) {
          await this.updateOrderWithFnbData(redirectPath, 'nextBtn');
        }
      }
    );
  };

  handleDeliveryTypeSelection = async deliveryType => {
    let orderObject = structuredClone(this.state.pendingOrderObject);
    let fnbItems = orderObject.fnb;
    fnbItems = fnbItems.map(item => {
      item.inSeatDelivery = deliveryType === 'pickup' ? false : item.inSeatDelivery;
      return item;
    });
    orderObject.fnb = fnbItems;

    if (window.constant.SHOW_DELIVERY_TYPE_DRAWER_BEFORE_BOOKING_SELECTION_DRAWER) {
      if (deliveryType === 'pickup') {
        this.setState(
          {
            pendingOrderObject: orderObject,
            showDeliveryTypeDrawer: false,
            deliveryTypeError: '',
            forcePickupSelection: false,
            isLoading: true,
          },
          async () => {
            await this.handleUpdateOrderWithFnbData(orderObject);
          }
        );
      } else if (this.state.orderType === 'fnb') {
        this.setState(
          {
            pendingOrderObject: orderObject,
            showDeliveryTypeDrawer: false,
            showBookingSelectionDrawer: true,
            deliveryTypeError: '',
            forcePickupSelection: false,
          }
        );
      } else {
        this.setState(
          {
            pendingOrderObject: orderObject,
            showDeliveryTypeDrawer: false,
            isLoading: true,
          },
          async () => {
            const isPickupAvailable = await this.checkPickupAvailability(orderObject);

            if (!isPickupAvailable) {
              this.setState({ isLoading: false });
              return;
            }

            if (isPickupAvailable?.[0]?.pickup === true) {
              this.setState({
                showDeliveryTypeDrawer: true,
                isLoading: false,
                deliveryTypeError: 'In-seat delivery is not available for this order. Please select pickup.',
                forcePickupSelection: true,
              });
              return;
            }

            this.setState(
              {
                isLoading: true,
                deliveryTypeError: '',
                forcePickupSelection: false,
              },
              async () => {
                await this.handleUpdateOrderWithFnbData(orderObject);
              }
            );
          }
        );
      }
      return;
    }

    this.setState({ pendingOrderObject: orderObject, isLoading: true }, async () => {
      if (deliveryType !== 'pickup' && this.state.orderType === 'fnb') {
        await this.handleUpdateOrderWithFnbData(orderObject);

        // Is delivery type selection is enabled then show the delivery type drawer else continue with default.
        if (window.constant.DELIVERY_TYPE_DRAWER_ENABLED) {
          this.handleShowDeliveryTypeDrawer();
        } else {
          await this.handleUpdateOrderWithFnbData(orderObject);
        }
      } else {
        // console.log(orderObject, 'orderObject after updating FNB items rishu');
        await this.handleUpdateOrderWithFnbData(orderObject);
      }
    });
  };

  handleBookingSelection = async () => {
    let orderObject = structuredClone(this.state.pendingOrderObject);
    const isFnbOrder = this.state.orderType === 'fnb';

    if (isFnbOrder) {
      orderObject.sessionid = this.state.bookedTicketDetails.sessionId;
      orderObject.deliveryseat = this.state.bookedTicketDetails?.deliveryseat ? this.state.bookedTicketDetails?.deliveryseat : '';
    }
    const isPickupAvailable = await this.checkPickupAvailability(orderObject);

    if (window.constant.SHOW_DELIVERY_TYPE_DRAWER_BEFORE_BOOKING_SELECTION_DRAWER) {
      if (!isPickupAvailable) {
        this.setState({ isLoading: false });
        return;
      }

      const pickupOnly = isPickupAvailable?.[0]?.pickup === true;
      if (pickupOnly) {
        this.setState({
          showBookingSelectionDrawer: false,
          showDeliveryTypeDrawer: true,
          isLoading: false,
          pendingOrderObject: orderObject,
          deliveryTypeError: 'In-seat delivery is not available for this order. Please select pickup.',
          forcePickupSelection: true,
        });
      } else {
        this.setState({
          showBookingSelectionDrawer: false,
          isLoading: false,
          pendingOrderObject: orderObject,
          deliveryTypeError: '',
          forcePickupSelection: false,
        });
        await this.handleUpdateOrderWithFnbData(orderObject);
      }
      return;
    }

    // Show delivery type drawer if enabled; otherwise continue with the default flow.
    const isDeliveryTypeDrawerEnabled = window.constant.SHOW_DELIVERY_TYPE.DELIVERY_TYPE_DRAWER_ENABLED;
    console.log(isDeliveryTypeDrawerEnabled, 'isDeliveryTypeDrawerEnabled');
    this.setState({
      showBookingSelectionDrawer: false,
      isLoading: false,
      pendingOrderObject: orderObject,
      ...(isDeliveryTypeDrawerEnabled && { showDeliveryTypeDrawer: true }),
    });

    if (!isDeliveryTypeDrawerEnabled) {
      console.log('handle update order called');
      await this.handleUpdateOrderWithFnbData(orderObject);
    }
    // console.log(orderObject, 'testing order object from handleBookingSelection');
  };

  checkPickupAvailability = async data => {
    this.setState({ isLoading: true });
    return await API.callEndpoint('POST', 'Bearer', '/order/v2/orders/pickup', data)
      .then(res => {
        this.setState({
          isPickupAvailable: res.data,
        });
        return res.data;
      })
      .catch(err => {
        showAlert();
        return null;
      });
  };

  checkFnbItemLimitAlert = fnbItem => {
    const { fnbDataForTicketSummary } = this.state;
    if (fnbDataForTicketSummary.length > 0 && Object.keys(fnbItem).length > 0) {
      var getSelectedItemCount = fnbDataForTicketSummary.filter(x => x.description.toLowerCase() == fnbItem.itemName.toLowerCase());
      var totalItemCount = 0;
      if (getSelectedItemCount.length > 0) {
        getSelectedItemCount.forEach(item => {
          totalItemCount += item.qty;
        });
        console.log(totalItemCount, 'totalItemCount---Add button');
        if (totalItemCount >= fnbItem.maximumqty) {
          this.showFnbItemLimitAlert(fnbItem);
          return true;
        }
      }
    }
  };

  handleFreeItemLimit = (cart = this.state.cart) => {
    const updatedCategories = this.syncFreeItemLimitState(this.state.setFreeFnbItemsData, cart);
    this.setState({ setFreeFnbItemsData: updatedCategories });
  };

  syncFreeItemLimitState = (freeItemsData = this.state.setFreeFnbItemsData, cart = this.state.cart) => {
    if (!Array.isArray(freeItemsData) || freeItemsData.length === 0) {
      return freeItemsData;
    }

    const quantityByItemId = new Map();
    (cart || [])
      .filter(item => item && (item.id || item.itemUniqueIdentifier))
      .forEach(item => {
        const cartItemId = item.itemUniqueIdentifier || item.id;
        const currentQty = Number(item.selectedQty || 1);
        quantityByItemId.set(cartItemId, (quantityByItemId.get(cartItemId) || 0) + currentQty);
      });

    return freeItemsData.map(category => {
      if (!category || !Array.isArray(category.fnbtabs_items)) {
        return category;
      }

      return {
        ...category,
        fnbtabs_items: category.fnbtabs_items.map(item => {
          const qtyInCart = quantityByItemId.get(item.id) || 0;
          const maxQty = Number(item.maximumqty || 0);
          const shouldDisable = qtyInCart > 0 && maxQty > 0 && qtyInCart >= maxQty;

          return {
            ...item,
            disableFreeItem: shouldDisable,
          };
        }),
      };
    });
  };

  showFnbItemLimitAlert = fnbItem => {
    showAlert({
      html: `<p>Sorry<span>You have reached the maximum order limit for the <strong>${fnbItem.itemName}</strong></span></p>`,
      iconHtml: `<img src="/assets/images/info-icon.svg" alt="info" />`,
      showCancelButton: false,
      cancelButtonText: 'CANCEL',
      showConfirmButton: true,
      confirmButtonText: 'OK',
      allowOutsideClick: false,
      allowEscapeKey: false,
      iconClasses: 'borderless',
      popupClasses: 'common-error-alert',
      onConfirm: () => {},
      onCancel: () => {},
    });
  };

  checkAlcoholItemsLimit = (alcoholItemsInCartCountTemp, cartItemIndex = null) => {
    // if (this.props.fnbData[this.state.activeCategoryIndex].ageRestriction != 1) return false;
    if (cartItemIndex === null) {
      if (this.props.fnbData[this.state.activeCategoryIndex].ageRestriction != 1) return false;
    } else {
      if (this.state.cart[cartItemIndex].ageRestrictionStatus != 1) return false;
    }
    if (alcoholItemsInCartCountTemp < this.state.alcoholItemsLimitPerOrder) {
      return false;
    } else {
      this.showOrderLimitAlert();
      return true;
    }
  };

  updateAlcoholItemsInCartCount = cart => {
    let alcoholItemsInCartCountTemp = 0;
    cart.map(fnbItem => {
      if (fnbItem.ageRestrictionStatus == 1) {
        alcoholItemsInCartCountTemp += fnbItem.selectedQty;
      }
    });
    if (alcoholItemsInCartCountTemp <= this.state.alcoholItemsLimitPerOrder) {
      this.setState({
        alcoholItemsInCartCount: alcoholItemsInCartCountTemp,
      });
    } else {
      this.showOrderLimitAlert();
    }
  };

  showOrderLimitAlert = () => {
    showAlert({
      html: `<p>Sorry<span>You can only add ${this.state.alcoholItemsLimitPerOrder} alcohol items to the cart</span></p>`,
      iconHtml: `<img src="/assets/images/info-icon.svg" alt="info" />`,
      showCancelButton: false,
      cancelButtonText: 'CANCEL',
      showConfirmButton: true,
      confirmButtonText: 'OK',
      allowOutsideClick: false,
      allowEscapeKey: false,
      iconClasses: 'borderless',
      popupClasses: 'common-error-alert',
      onConfirm: () => {},
      onCancel: () => {},
    });
  };

  checkIfUpdateOrderFunctionisAvailable = () => {
    if (this.props.updateOrder != false) {
      this.props.updateOrder(this.state.cart);
      this.setState({
        cart: [],
      });
    }
  };

  backBtnClick = () => {
    this.setState({ backBtnClicked: true });
    var getSessionIdFromLocalstorage = localStorage.getItem('sesstionid');
    if (this.state.orderType === 'ticketing') {
      this.updateOrderWithFnbData(`/seatlayout?sessionid=${getSessionIdFromLocalstorage}`);
    } else if (this.state.orderType === 'fnb') {
      let orderId = JSON.parse(localStorage.getItem('orderId'));
      if (orderId) {
        if (orderId.expiry < Date.now()) {
          showAlert({
            html: `<p>Your order has expired</p>`,
            iconHtml: `<img src="/assets/images/info-icon.svg" alt="info" />`,
            showCancelButton: false,
            cancelButtonText: 'CANCEL',
            showConfirmButton: true,
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            allowEscapeKey: false,
            iconClasses: 'borderless',
            popupClasses: 'common-error-alert',
            onConfirm: () => {
              // // // // // this.redirectToLoginPage();
              if (window.constant.ENABLE_VOUCHERS === 'true') {
                this.backBtnRedirect();
              } else {
                this.redirectToLoginPage();
              }
            },
            onCancel: () => {},
          });
        } else {
          showAlert({
            html: `<p>Going back will cancel your current order, and you will need to start again. <span>Do you wish to change?</span></p>`,
            iconHtml: `<img src="/assets/images/info-icon.svg" alt="info" />`,
            showCancelButton: true,
            cancelButtonText: 'CANCEL',
            showConfirmButton: true,
            confirmButtonText: 'Yes',
            allowOutsideClick: false,
            allowEscapeKey: false,
            iconClasses: 'borderless',
            popupClasses: 'common-error-alert',
            reverseButtons: true,
            onConfirm: async () => {
              await this.cancelOrder(orderId.id);
              this.setState(
                {
                  cartData: [],
                  orderId: null,
                },
                () => {
                  localStorage.removeItem('orderId');
                  localStorage.removeItem('cartData');
                  localStorage.removeItem('bookingid');
                  // // // // // this.redirectToLoginPage();
                  if (window.constant.ENABLE_VOUCHERS === 'true') {
                    this.backBtnRedirect();
                  } else {
                    this.redirectToLoginPage();
                  }
                }
              );
              // // // // // localStorage.removeItem("orderId");
              // // // // // localStorage.removeItem("cartData");
              // // // // // localStorage.removeItem("bookingid");
              // // // // // this.redirectToLoginPage();
            },
            onCancel: () => {
              this.setState({
                backBtnClicked: false,
              });
            },
          });
        }
      } else {
        // // // // // this.redirectToLoginPage();
        if (window.constant.ENABLE_VOUCHERS === 'true') {
          this.backBtnRedirect();
        } else {
          this.redirectToLoginPage();
        }
      }
    }
    // window.location.href = `/seatlayout?sessionid=${getSessionIdFromLocalstorage}`;
  };

  redirectToLoginPage = () => {
    document.cookie = 'accessToken=;max-age=0';
    document.cookie = 'refreshToken=;max-age=0';
    document.cookie = 'firstname=;max-age=0';
    document.cookie = 'lastname=;max-age=0';
    document.cookie = 'email=;max-age=0';
    document.cookie = 'phonenumber=;max-age=0';
    document.cookie = 'guestphonenumber=;max-age=0';
    localStorage.removeItem('cartData');
    localStorage.removeItem('orderId');
    window.location.href = `/login`;
  };

  cancelOrder = async orderId => {
    this.setState({
      isLoading: true,
    });
    await API.callEndpoint('DELETE', 'Bearer', `/order/v2/orders/${orderId}`)
      .then(res => console.log('order cancelled'))
      .catch(err => console.log(err))
      .finally(() => {
        this.setState({ isLoading: false });
      });
  };

  checkNextBtnDisable = () => {
    let orderType = localStorage.getItem('orderType');
    if (orderType === 'ticketing') {
      return !(this.state.ticketsDataForTicketSummary.length > 0);
    } else {
      return this.state.cart.length == 0;
    }
  };

  populateDirectItemsAddedToCart = () => {
    var itemsAddedToCart = '',
      returnArray = [];
    this.state.itemsAddedToCart.map(directItem => {
      var qty = directItem.qty == 1 ? '' : ' x ' + directItem.qty;
      itemsAddedToCart = <p className="itemAddedToCartMsg">{`${directItem.name + qty} added to cart`}</p>;
      returnArray.push(itemsAddedToCart);
    });
    return returnArray;
  };

  handleFnbSectionDisable = buttonFlag => {
    // Checking package voucher ticket types without required minQty.
    if (window.constant.ENABLE_VOUCHERS == 'true' && this.state.voucherFnbData.length > 0) {
      const vouchersData = this.state.voucherFnbData[0].fnbtabs_items;
      const cartData = this.state.cart;
      var voucherFNBWithoutRequiredQty = 0;
      vouchersData.map(fnbItem => {
        if (!fnbItem.disableVoucherItem) {
          var itemsFromCart = cartData.filter(x => x.id === fnbItem.id);
          if (itemsFromCart.length == 0) {
            voucherFNBWithoutRequiredQty = voucherFNBWithoutRequiredQty + 1;
          } else {
            var getTotalQty = 0;
            const cartItemsOfCurFnbItem = itemsFromCart.filter(x => x.id === fnbItem.id);
            cartItemsOfCurFnbItem.map(cartItem => {
              getTotalQty = getTotalQty + cartItem.selectedQty;
            });
            if (getTotalQty < fnbItem.maximumqty) {
              voucherFNBWithoutRequiredQty = voucherFNBWithoutRequiredQty + 1;
            }
          }
        }
      });
      console.log('voucherFNBWithoutRequiredQty: ', voucherFNBWithoutRequiredQty);
      if (voucherFNBWithoutRequiredQty > 0) {
        showAlert({
          html: `<p>There are some ${window.constant.FNB_TEXT_CONTENT} Vouchers you have not redeemed. Would you like to redeem them now?</p>`,
          iconHtml: `<img src=${voucherErrorIcon}>`,
          showCancelButton: true,
          showConfirmButton: true,
          confirmButtonText: 'Redeem Now',
          cancelButtonText: 'Skip',
          allowOutsideClick: false,
          allowEscapeKey: false,
          iconClasses: 'borderless',
          popupClasses: 'common-error-alert fnb-section-disabled',
          onConfirm: () => {},
          onCancel: () => {
            this.fnbSectionDisable(buttonFlag);
          },
        });
      } else {
        this.fnbSectionDisable(buttonFlag);
      }
    } else {
      this.fnbSectionDisable(buttonFlag);
    }
  };

  fnbSectionDisable = getBtnWrap => {
    console.log(getBtnWrap, 'getBtnWrap');
    if (window.constant.FNB_SECTION_DISABLE == 'true' && this.state.fnbDataForTicketSummary.length != 0) {
      this.setState(
        {
          isLoading: true,
        },
        () => {
          var getCinemaId = this.state.cinemaId;
          var data = {
            cinemaid: getCinemaId,
          };
          if (this.state.sessionId && this.state.sessionId != 'null') {
            data.sessionid = this.state.sessionId;
          }
          var orderType = this.state.orderType;
          API.callEndpoint('POST', 'Bearer', '/cms/v2/fnb/section/disable', data)
            .then(response => {
              this.setState(
                {
                  isLoading: false,
                },
                () => {
                  console.log(response.data, 'Fnb disable response');
                  var getDisableResponse = response.data;
                  if (getDisableResponse && getDisableResponse.cinemaid == getCinemaId && getDisableResponse.disabled) {
                    showAlert({
                      html: `<p class="fnb-disabled-text">Food & Drink Orders<span>The Cinema is closed for Food & Drink Orders from this kiosk.</span>${
                        orderType == 'ticketing' ? `${getBtnWrap == 'nextBtn' ? `<span>Proceed to payment without Food & Beverages?</span>` : `<span>Proceed without Food & Beverages?</span>`}` : ''
                      }</p>`,
                      iconHtml: `<img src="/assets/images/info-icon.svg" alt="info" />`,
                      showCancelButton: orderType == 'ticketing' && getBtnWrap == 'nextBtn' ? true : false,
                      cancelButtonText: 'No',
                      showConfirmButton: true,
                      confirmButtonText: orderType == 'ticketing' && getBtnWrap == 'nextBtn' ? 'Yes' : 'OK',
                      allowOutsideClick: false,
                      allowEscapeKey: false,
                      iconClasses: 'borderless',
                      popupClasses: 'common-error-alert fnb-section-disabled',
                      onConfirm: () => {
                        if (orderType == 'ticketing') {
                          this.setState(
                            {
                              cart: [],
                              fnbDataForTicketSummary: [],
                            },
                            () => {
                              if (getBtnWrap == 'nextBtn') {
                                this.updateOrderWithFnbData(undefined, getBtnWrap);
                              } else {
                                this.backBtnClick();
                              }
                            }
                          );
                        } else {
                          let cinemaId = localStorage.getItem('cinemaid');
                          if (cinemaId) {
                            window.location.href = `/?cinemaid=${cinemaId}`;
                          }
                        }
                      },
                      onCancel: () => {},
                    });
                  } else {
                    if (getBtnWrap == 'nextBtn') {
                      console.log('else if getBtnWrap == nextBtn from fnbSectionDisable after disable endpoint');
                      this.updateOrderWithFnbData(undefined, getBtnWrap);
                    } else {
                      this.backBtnClick();
                    }
                  }
                }
              );
            })
            .catch(error => {
              this.setState({
                isLoading: false,
              });
              console.log(error.error, 'Fnb disable error');
            });
        }
      );
    } else {
      if (getBtnWrap == 'nextBtn') {
        console.log('if getBtnWrap == nextBtn from fnbSectionDisable');
        this.updateOrderWithFnbData(undefined, getBtnWrap);
      } else {
        this.backBtnClick();
      }
    }
  };

  updateFNBCountInvoucherFnbData = async (cart, populateFromLocalStorage) => {
    var tempvoucherFnbData = this.state.voucherFnbData;
    var fnbCartData = cart;

    // Updating totalSeatsSelected(based on ticketType code) & disableTicketTypeStatus(based on voucher Code) for voucher tickettypes.
    tempvoucherFnbData.map(voucherCategory => {
      voucherCategory.fnbtabs_items.map(voucherItem => {
        var dealIdWithMultipleItems = this.state.voucherFnbData[0].fnbtabs_items.filter(x => x.voucherDealId && voucherItem.voucherDealId && x.voucherDealId === voucherItem.voucherDealId);
        if (dealIdWithMultipleItems.length > 1) {
          // dealId with Multiple Items.
          var voucherItemsInCartTotalQty = 0;
          var voucherItemsInCart = fnbCartData.filter(x => x.voucherCodes && x.voucherCodes.length > 0 && x.id === voucherItem.id);
          if (voucherItemsInCart.length) {
            voucherItemsInCart.map(cartItem => {
              voucherItemsInCartTotalQty = voucherItemsInCartTotalQty + cartItem.selectedQty;
            });
          }

          if (!populateFromLocalStorage && voucherItem.id === this.state.selectedItemId) {
            voucherItem.totalItemsAdded = voucherItemsInCartTotalQty;
          } else if (populateFromLocalStorage) {
            voucherItem.totalItemsAdded = voucherItemsInCartTotalQty;
          }

          var dealIdBasedItemsQty = 0;
          var dealIdBasedItems = fnbCartData.filter(x => x.voucherCodes && x.voucherCodes.length > 0 && x.voucherDealId === voucherItem.voucherDealId);
          if (dealIdBasedItems.length) {
            dealIdBasedItems.map(cartItem => {
              dealIdBasedItemsQty = dealIdBasedItemsQty + cartItem.selectedQty;
            });
          }

          dealIdWithMultipleItems.map(dFnbItem => {
            var itemFindIndex = tempvoucherFnbData[0].fnbtabs_items.findIndex(x => x.id === voucherItem.id);
            if (itemFindIndex != -1) {
              if (dealIdBasedItemsQty >= dFnbItem.maximumqty) {
                tempvoucherFnbData[0].fnbtabs_items[itemFindIndex].disableVoucherItem = true;
              } else {
                tempvoucherFnbData[0].fnbtabs_items[itemFindIndex].disableVoucherItem = false;
              }
            }
          });
        } else {
          // dealId with Single Item.
          var voucherItemsInCart = fnbCartData.filter(x => x.voucherCodes && x.voucherCodes.length > 0 && x.id === voucherItem.id);
          var voucherItemsInCartTotalQty = 0;
          if (voucherItemsInCart.length > 0) {
            voucherItemsInCart.map(cartItem => {
              voucherItemsInCartTotalQty = voucherItemsInCartTotalQty + cartItem.selectedQty;
            });
          }
          voucherItem.totalItemsAdded = voucherItemsInCartTotalQty;
          if (voucherItemsInCartTotalQty >= voucherItem.maximumqty) {
            voucherItem.disableVoucherItem = true;
          } else {
            voucherItem.disableVoucherItem = false;
          }
        }
      });
    });

    this.setState(
      {
        voucherFnbData: tempvoucherFnbData,
      },
      async () => {
        console.log('updateFNBCountInvoucherFnbData() > this.state.voucherFnbData: ', this.state.voucherFnbData);
      }
    );
  };

  backBtnRedirect = () => {
    const vouchers = JSON.parse(localStorage.getItem('vouchersScanned'));
    if (vouchers != null && vouchers.length > 0) {
      window.location.href = `/yourvouchers`;
    } else {
      window.location.href = `/addvouchers`;
    }
  };

  handleShowDeliveryTypeDrawer = () => {
    this.setState({ showDeliveryTypeDrawer: !this.state.showDeliveryTypeDrawer });
  };
  handleBookingSelectionDrawer = () => {
    this.setState({ showBookingSelectionDrawer: !this.state.showBookingSelectionDrawer });
  };

  updateBookedTicketDetails = (bookingDetails, callback) => {
    // console.log(bookingDetails, "booking details from updateBookedTicketDetails");
    // console.log(callback, "callback from updateBookedTicketDetails");
    this.setState({ bookedTicketDetails: structuredClone(bookingDetails) }, () => {
      callback();
    });
  };

  getFreeRecognitionFnbItem = () => {
    if (window.constant.FREE_RECOGNITION_ITEM && API.getValueFromCookie('firstname') && API.getValueFromCookie('lastname')) {
      this.setState(
        {
          freeRecognitionItemsData: [],
          freeFnbItemsDataLoading: true,
        },
        () => {
          let orderType = localStorage.getItem('orderType');
          var payloadData = {};
          if (this.state.sessionId && orderType == 'ticketing') {
            payloadData = {
              sessionid: this.state.sessionId,
            };
          } else {
            payloadData = {
              cinemaid: this.state.cinemaId,
            };
          }
          API.callEndpoint('POST', 'Bearer', '/order/v2/rewards/fnbs', payloadData)
            .then(response => {
              this.setState({
                setFreeFnbItemsData: response.data,
                freeFnbItemsDataLoading: false,
              });
            })
            .catch(error => {
              this.setState({ freeFnbItemsDataLoading: false });
              console.log(error.error, 'free Recognition FnbItem--error');
            });
        }
      );
    }
  };

  render() {
    let { fnbData, activeCategoryIndex, fnbDataForTicketSummary, ticketsDataForTicketSummary, voucherFnbData, setFreeFnbItemsData } = this.state;
    let { showFooter, showCategoriesSelection } = this.props;
    // // // // // console.log("FNB Component > voucherFnbData: ", voucherFnbData);
    return (
      <>
        <Loader loader={this.state.isLoading} />

        {((window.constant.ENABLE_VOUCHERS === 'true' && this.props.disableVoucherSection) ||
          (setFreeFnbItemsData.length > 0 && setFreeFnbItemsData[0]?.fnbtabs_items.length > 0 && window.constant.FREE_RECOGNITION_ITEM)) && (
          <section className="redeem-fnb-vouchers-container">
            <section className="fnb-vouchers-block">
              <aside className="fnb-vouchers-block-header">
                <h2>{window.constant.REWARDS_VOUCHERS_FNB_SECTION_HEADING}</h2>
              </aside>
              <section className="fnb-vouchers-block-body">
                <section className="fnb-items-container voucherfnb-items-container horizontal">
                  <div key={0} className={`fnb-items-list voucherfnb-items-list`}>
                    {window.constant.ENABLE_VOUCHERS == 'true' &&
                      this.props.disableVoucherSection &&
                      voucherFnbData.map(voucherCategory => {
                        return voucherCategory.fnbtabs_items.map((item, index) => {
                          return (
                            <FnbItemCard
                              key={index}
                              tabId={voucherCategory.id}
                              item={item}
                              itemIndex={index}
                              // // // // // addToCartButtonClick={this.addToCartButtonClick}
                              addToCartButtonClick={this.addToCartButtonClickVouchers}
                              sort={item.sort}
                            />
                          );
                        });
                      })}

                    {setFreeFnbItemsData.length > 0 &&
                      window.constant.FREE_RECOGNITION_ITEM &&
                      API.getValueFromCookie('firstname') &&
                      API.getValueFromCookie('lastname') &&
                      setFreeFnbItemsData.map((category, categoryIndex) => {
                        return (
                          <>
                            {category.fnbtabs_items.map((item, index) => {
                              return <FnbItemCard key={index} tabId={category.id} item={item} itemIndex={index} addToCartButtonClick={this.addToCartButtonClick} />;
                            })}
                          </>
                        );
                      })}
                  </div>
                  {this.state.voucherFnbDataLoading && this.state.freeFnbItemsDataLoading && (
                    <div className="fnb-items-list">
                      {Array.from({ length: 3 }).map((item, index) => {
                        return (
                          <div className="fnb-item-card-loader" style={{ width: '33.33%', padding: '25px 10px' }}>
                            <Skeleton height={200} width={'100%'} />
                            <Skeleton height={30} width={'100%'} style={{ marginTop: 20, marginBottom: 30 }} />
                            <div className="d-flex justify-content-between align-items-center">
                              <div>
                                <Skeleton height={20} width={140} />
                                <Skeleton height={20} width={140} />
                              </div>
                              <Skeleton height={50} width={120} />
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </section>
              </section>
            </section>
          </section>
        )}

        {showCategoriesSelection ? (
          fnbData && fnbData.length > 0 ? (
            <FnbCategoriesHeader fnbData={fnbData} activeCategoryIndex={activeCategoryIndex} handleActiveCategory={this.handleActiveCategory} />
          ) : (
            <div className="d-flex justify-content-center mt-4 mb-3" style={{ gap: '0 15px' }}>
              {Array.from({ length: 6 }).map((item, index) => {
                return <Skeleton height={60} width={160} style={{ borderRadius: '6px' }} />;
              })}
            </div>
          )
        ) : (
          <></>
        )}

        <div className={`fnb-items-container ${this.props.horizontal ? 'horizontal' : ''}`}>
          {showCategoriesSelection ? (
            <>
              {fnbData.map((category, categoryIndex) => {
                return (
                  <div key={categoryIndex} className={`fnb-items-list ${activeCategoryIndex === categoryIndex ? '' : 'd-none'}`}>
                    {category.fnbtabs_items.map((item, index) => {
                      return <FnbItemCard key={index} tabId={category.id} item={item} itemIndex={index} addToCartButtonClick={this.addToCartButtonClick} />;
                    })}
                  </div>
                );
              })}
            </>
          ) : (
            <div key={0} className={`fnb-items-list`}>
              {fnbData.map(category => {
                return category.fnbtabs_items.map((item, index) => {
                  return <FnbItemCard key={index} tabId={category.id} item={item} itemIndex={index} addToCartButtonClick={this.addToCartButtonClick} sort={item.sort} />;
                });
              })}
            </div>
          )}

          {this.state.dataLoading && (
            <div className="fnb-items-list">
              {Array.from({ length: 10 }).map((item, index) => {
                return (
                  <div className="fnb-item-card-loader" style={{ width: '33.33%', padding: '25px 10px' }}>
                    <Skeleton height={200} width={'100%'} />
                    <Skeleton height={30} width={'100%'} style={{ marginTop: 20, marginBottom: 30 }} />
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <Skeleton height={20} width={140} />
                        <Skeleton height={20} width={140} />
                      </div>
                      <Skeleton height={50} width={120} />
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
        <Modifiers
          showModifierModal={this.state.showModifierModal}
          fnbActiveItemIndex={this.state.fnbActiveItemIndex}
          populateItemImage={this.populateItemImage}
          selectedItem={this.state.selectedItem}
          populateModifierItem={this.populateModifierItem}
          incDecItem={this.incDecItem}
          calculateItemTotal={this.calculateItemTotal}
          checkIfBtnIsDisabled={this.checkIfBtnIsDisabled}
          proceedBtnClick={this.proceedBtnClick}
          closeModifierModal={this.closeModifierPopup}
          windowWidth={this.state.windowWidth}
        ></Modifiers>
        <AgeRestriction
          windowWidth={this.state.windowWidth}
          showAgeRestrictionModal={this.state.showAgeRestrictionModal}
          closeAgeRestrictionPopup={this.closeAgeRestrictionPopup}
          closeBtnAgeRestrictionPopup={this.closeBtnAgeRestrictionPopup}
        ></AgeRestriction>
        {showFooter ? (
          <PurchaseFooter
            fnbDataForTicketSummary={fnbDataForTicketSummary}
            ticketsDataForTicketSummary={ticketsDataForTicketSummary}
            ticketsTaxValue={this.state.ticketsTaxValue}
            fnbTaxValue={this.state.fnbTaxValue}
            incDecItem={this.incDecItem}
            updateOrderWithFnbData={this.updateOrderWithFnbData}
            nextBtnText={this.state.orderType === 'ticketing' ? (fnbDataForTicketSummary.length == 0 ? 'SKIP' : 'CONTINUE') : 'CONTINUE'}
            // nextBtnClick={this.updateOrderWithFnbData}
            // // // // // nextBtnClick={() => this.fnbSectionDisable("nextBtn")}
            nextBtnClick={() => this.handleFnbSectionDisable('nextBtn')}
            nextBtnDisable={this.checkNextBtnDisable()}
            // backBtnClick={this.backBtnClick}
            backBtnClick={() => this.fnbSectionDisable('backBtn')}
            showDeliveryTypeDrawer={this.state.showDeliveryTypeDrawer}
            handleShowDeliveryTypeDrawer={this.handleShowDeliveryTypeDrawer}
            handleDeliveryTypeSelection={this.handleDeliveryTypeSelection}
            isLoading={this.state.isLoading}
            showBookingSelectionDrawer={this.state.showBookingSelectionDrawer}
            handleBookingSelectionDrawer={this.handleBookingSelectionDrawer}
            handleFnbSectionDisable={this.handleFnbSectionDisable}
            updateBookedTicketDetails={this.updateBookedTicketDetails}
            handleBookingSelection={this.handleBookingSelection}
            isPickupAvailable={this.state.isPickupAvailable}
            deliveryTypeError={this.state.deliveryTypeError}
            forcePickupSelection={this.state.forcePickupSelection}
          />
        ) : (
          <></>
        )}
        <Offcanvas show={this.state.itemsAddedToCart.length == 0 ? false : true} backdrop={false} placement={'bottom'} className="addedToCartDrawer">
          <Offcanvas.Body id="directItemsAddedToCartOffcanvasBody">
            <BsCartCheckFill className="icon" />
            {this.populateDirectItemsAddedToCart()}
          </Offcanvas.Body>
        </Offcanvas>

        <Offcanvas
          show={this.state.openTicketSummary}
          placement={'bottom'}
          onHide={() =>
            this.setState({
              openTicketSummary: false,
            })
          }
          className="purchaseFooter"
        >
          <Offcanvas.Header closeButton></Offcanvas.Header>
          <Offcanvas.Body>
            <div id="ticketSummarySection" className="bookingSummary" ref={this.ticketSummarySectionRef} style={{ maxHeight: this.state.maxHeightForTicketSummary }}>
              <p className="bookingSummaryHeading">Some Items are currently Unavailable</p>
              <p className="bookingSummaryDescription">Some of the items are sold out, Press continue to go ahead with removing the sold out items or edit your orders yourself.</p>
              <BookingSummary
                ticketsDataForTicketSummary={this.state.ticketsDataForTicketSummary}
                fnbDataForTicketSummary={this.state.fnbDataForTicketSummary}
                incDecItem={this.incDecItem}
                nextBtnClick={this.handleContinueWithoutSoldOutItems}
                nextBtnText={'Continue'}
                bookingFee={false}
                tax={window.constant.SHOW_TAX_VALUE_ON_ORDER_TOTAL_ON_SEAT_LAYOUT === 'true' ? this.state.ticketsTaxValue + this.state.fnbTaxValue : false}
              ></BookingSummary>
            </div>
          </Offcanvas.Body>
        </Offcanvas>
      </>
    );
  }
}

export default FNBComponent;
